import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

import { calendarDayNumberMap, config, messages, time } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { DataService, DateService, HelperService, HTTPService } from 'app/services';

import { CancelApptDialogComponent } from '../cancel-appt-dialog/cancel-appt-dialog.component';
import { UpdateApptDialogComponent } from '../update-appt-dialog/update-appt-dialog.component';
import { UpdateRecipientDialogComponent } from '../update-recipient-dialog/update-recipient-dialog.component';

import { find, findIndex, intersection, isEqual, sortBy, uniqWith } from 'lodash';
import * as moment from 'moment';
import tippy, { Instance } from 'tippy.js';
enum Statuses {
  missing = 'missing',
  completed = 'completed',
  nostoredtires = 'nostoredtires',
}

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
})
export class AppointmentComponent implements OnInit, OnChanges, OnDestroy {
  private _initialTemplates: any;
  @Input('onSubmitData')
  set onSubmitData(data: any) {
    if (data && data.active === 'add-appointment') {
      this.onSubmit();
    }
  }
  /**
   * The data is coming from calendar when user click
   * on any slot or reschedule
   */
  @Input('appointmentData')
  set appointmentData(data: any) {
    if (!data) {
      return;
    }
    this.defaultTechnicianId = data._id ? '' : data.resourceId;

    if (data.props && data.props.param) {
      this.param = data.props.param;
    }

    if (!data._id && data.resourceId && this.technician?.length) {
      this.checkSelectedTechnician([{ techId: data.resourceId }]);
    }

    if (data.appointmentData && data.appointmentData.estimate) {
      this.estimateId = data.appointmentData.estimate.estimateId;
    }

    /** Get and populate already created appointment */
    const appointment = data.appointmentData;

    if (data._id && appointment) {
      this.isUpdate = true;
      const endTime = new Date(appointment.endDateTime).getTime();
      const startTime = new Date(appointment.startDateTime).getTime();
      this.duration = (endTime - startTime) / 60000;
      if (data.props && data.props.appointment && data.props.appointment.appointmentId) {
        this.appointment._id = data.props.appointment.appointmentId;
        this.getAppointmentById(this.appointment._id);
      } else {
        this.getAppointmentById(data._id);
      }
    } else {
      this.isCustomerFocused = true;
    }

    if (data.isOpenBlockTab) {
      this.appointment.isOpenBlockTab = data.isOpenBlockTab;
    }

    // Populate rest of the appointment available data
    if (data.title) {
      this.appointment.title = data.title;
    }

    if (data.color) {
      this.appointment.color = data.color;
    }

    if (data.time && data.date.start && data.date.end) {
      this.appointment.date.start = data.date.start;
      this.appointment.date.end = data.date.end;
    }

    if (data.props && data.props._id && data.props.type !== 'block') {
      this.appointmentRequest = data.props;
      this.timeWhenAppointmentCreated = data;

      let categoryServices: any = [];
      data.props &&
        data.props.serviceCategories &&
        data.props.serviceCategories.map((x) => {
          if (x.services && x.services?.length > 0) {
            x.services.map((y) => {
              if (y && y.name) {
                categoryServices.push(y.name);
              }
            });
          }
        });
      categoryServices = categoryServices.join(', ');

      this.appointment.notes = `Vehicle YMM: ${(this.appointmentRequest.vehicle && this.appointmentRequest.vehicle.name) || ''}\n\nVehicle drop off: ${this.appointmentRequest.isVehicleDropOff ? 'Yes' : 'NO'
        }\n\nServices: ${categoryServices || ''}\n\nProblem:${this.appointmentRequest.description || ''}`;
      // this.concern[0].notes = this.appointmentRequest.description || '';
      if (this.concern?.length) {
        this.concern[0].notes = this.appointmentRequest.description || '';
      }
      if (data.appointmentData && data.appointmentData.vehicle && data.appointmentData.vehicle.name) {
        this.appointmentReqVehicle = { name: '' };
        this.appointmentReqVehicle.name = data.appointmentData.vehicle.name;
      } else {
        if (this.appointmentRequest.vehicle && this.appointmentRequest.vehicle.name) {
          this.appointmentReqVehicle = { name: '' };
          this.appointmentReqVehicle.name = this.appointmentRequest.vehicle.name;
          this.vehicleSearchData = this.appointmentReqVehicle.name;
        }
      }

      if (data.props && data.props.customer) {

        // ✅ Save flags in customer object
        this.isMarketingNotifEnabled = data.props.isMarketingNotifEnabled ?? false;
        this.isOperationalNotifEnabled = data.props.isOperationalNotifEnabled ?? false;

        this.customerSearchKey = this.helperService.trimString(`${data.props.customer.firstName} ${data.props.customer.lastName}`);
        this.customerSearchData = this.customerSearchKey;
        this.customerSearch(data.props.customer.phone, true);
        this.customerSearch(this.customerSearchKey);
      }

    } else {
      this.appointment.notes = '';
    }
    if (data.props && data.props.type === 'block') {
      this.blockTab = true;
      this.appointmentTab = false;
      this.appointment.isOpenBlockTab = true;
      this.hideAppointmentTab = true;
      this.appointment.hideAppointmentTab = this.hideAppointmentTab;
      this.appointment.description = data.props.description;
      this.appointment._id = data.props._id;
    }

    if (data.time && data.time.start && data.time.end) {
      this.appointment.time.start = data.time.start;
      this.appointment.time.end = data.time.end;
      this.setSelectedTime();
    }

    if (data.props) {
      if (data.props.leadCampaign && data.props.leadCampaign.leadCampaignId) {
        this.appointment.leadCampaign = data.props.leadCampaign;
        this.sourceCampaign = data.props.leadCampaign;
      } else if (data.props.followUpCampaign && data.props.followUpCampaign.campaignId) {
        this.appointment.followUpCampaign = data.props.followUpCampaign;
        this.sourceCampaign = data.props.followUpCampaign;
      } else if (data.props.marketingCampaign && data.props.marketingCampaign.marketingCampaignId) {
        this.appointment.followUpCampaign = data.props.marketingCampaign;
        this.sourceCampaign = data.props.marketingCampaign;
      }
    }
  }
  /**
   * The data is coming from add dialog when user click
   * on add appointment from the sidebar
   */
  @Input('inputCustomer')
  set inputCustomer(customer: any) {
    if (customer && customer._id) {
      this.appointment.customer.customerId = customer._id;
      this.appointment.customer.contactOnPhone = customer.contactOnPhone;
      this.appointment.customer.contactOnEmail = customer.contactOnEmail;
      this.getCustomerForAppointment(customer._id, customer.isCreatedForOther);
      this.isCustomerFocused = false;
      this.currentLang = customer.preferredLanguage || 'en';
      // this.focus.vehicle = true;
    }
  }
  /**
   * The data is coming from add dialog when user click
   * on add appointment from the estimate
   */
  @Input('inputEstimate')
  set inputEstimate(estimate: any) {
    if (estimate && estimate.customer.customerId) {
      this.appointment.title = estimate.title;
      this.customerSearchKey = estimate.customer.fullNameQBO;
      this.currentLang = estimate.currentLang || 'en';
      /** Populating customer data */
      this.customer = this.helperService.deepCopy(estimate.customer);
      this.appointment.customer = this.helperService.deepCopy(estimate.customer);
      this.setCustomFleetSettings(estimate.customer);

      if (estimate && estimate.vehicle && estimate.vehicle.vehicleId) {
        this.appointment.vehicle = {
          vehicleId: estimate.vehicle.vehicleId,
          name: estimate.vehicle.name,
          year: estimate.vehicle.year,
          make: estimate.vehicle.make,
          model: estimate.vehicle.model,
          engine: estimate.vehicle.engine,
          _id: estimate.vehicle.vehicleId,
        };

        this.selectedVehicle = this.appointment.vehicle;
        this.acFocusLabel.vehicle = this.appointment.vehicle.name;
        this.setVehicleAdditionalDetails(estimate.vehicle);
      }

      if (estimate.leadCampaign && estimate.leadCampaign.leadCampaignId) {
        this.appointment.leadCampaign = estimate.leadCampaign;
        this.sourceCampaign = estimate.leadCampaign;
      } else if (estimate.followUpCampaign && (estimate.followUpCampaign.marketingCampaignId || estimate.followUpCampaign.campaignId)) {
        this.appointment.followUpCampaign = estimate.followUpCampaign;
        this.sourceCampaign = estimate.followUpCampaign;
      } else if (estimate.marketingCampaign && estimate.marketingCampaign.marketingCampaignId) {
        this.appointment.followUpCampaign = estimate.marketingCampaign;
        this.sourceCampaign = estimate.marketingCampaign;
      }

      if (estimate.estimate?.estimateId?._id) {
        const estimateId = estimate.estimate?.estimateId?._id;
        this.httpService.getOrderConcerns({ orderId: estimateId }).then((concern) => {
          if (concern?.length)
            // this.concern = concern;
            this.concern = concern.sort((a, b) => a.index - b.index);
        });
      }

      this.setColor();
      this.acNotDisable.customer = false;
      this.appointment.estimate = estimate.estimate;
      this.acFocusLabel.estimate = this.appointment.estimate.title;

      if (this.appointment.estimate && this.appointment.estimate.estimateId) {
        const { code, title, _id } = this.appointment.estimate.estimateId;
        this.appointment.estimate.estimateId = _id;
        this.estimateSearchKey = `${title || this.defaultTitle} - ${code}`;
      }

      this.appointment.switch.confirmation = true;
      this.appointment.switch.reminders = true;
      this.sideAccordionVisible = true;
      this.acNotDisable.estimate = false;
      this.isCustomerFocused = false;
      this.appointment.vehicles = estimate.vehicles;
      this.getCustomerContact();
      this.checkPreferredLocation(estimate.customer);
      this.getTireStorageData(this.appointment?.customer?.customerId || this.appointment?.customer?._id, this.appointment?.vehicle?.vehicleId);
    }
  }
  @Input() openFrom: any;
  @Input() setProcessingState: any;
  @Input() setTaxExemptReasons: any;
  @Input() setCompanyData: any;
  @Input() setAppointmentColors: any;
  @Input() isProcessing: boolean;
  @Input() isOpenFromCreateCustomer: boolean = false;

  @Output() appointmentCreated = new EventEmitter();
  @Output() createCustomer = new EventEmitter();
  @Output() createVehicle = new EventEmitter();
  @Output() setCurrentCustomerLang = new EventEmitter();

  @ViewChild('addAppointemnt', { static: true }) addAppointemnt;
  @ViewChild('confirmationContentEl')
  confirmationContentEl: ElementRef;
  @ViewChild('reminderContentEl')
  reminderContentEl: ElementRef;
  @ViewChild('manualConfirmationContentEl')
  manualConfirmationContentEl: ElementRef;
  @ViewChild('manualCanceledContentEl')
  manualCanceledContentEl: ElementRef;
  @ViewChild('startDateCalendarContainer')
  startDateCalendarContainer: ElementRef;

  tippyInstances: any = {};
  endDate: any = '';
  isFetchingContacts: boolean = false;
  isLogsLoading: boolean = false;
  activities: any[] = [];
  estimateVehicleId: string = '';
  times = time;
  allTimes = time;
  focus: any = {};
  customerSearchKey: any;
  estimateId: any = '';
  apptId: any = '';
  customerSearchResults: any[] = [];
  defaultCustomerSearch: any[] = [];
  vehicleSearchResults: any[] = [];
  vehicleType: any = { active: [], inactive: [] };
  customerSearchData: string = '';
  vehicleSearchData: string = '';
  defaultTitle: string = config.defaultTitle;
  isPastStartDate: boolean = false;
  estimateSearchKey: any;
  estimateSearchResults: any;
  estimateSearchData: any;
  reminders: any[] = [];
  today: any = '';
  oldappointment: any;
  selectedVehicle: any;
  appointmentReqVehicle: any;
  sourceCampaign: any = {};
  selectedTime: any = {
    start: '',
    end: '',
  };
  endTimeDropdown: any[] = [];
  isActiveEndTime: boolean;
  isAddReminderOpen: boolean = false;
  isReminderDisabled: boolean = true;
  unsubscriptionTooltip: string = '';
  businessDays: any = {};
  appointment: any = {
    _id: null,
    title: null,
    color: null,
    date: {
      start: '',
      end: '',
    },
    time: {
      start: '',
      end: '',
    },
    vehicle: {
      vehicleId: null,
      name: null,
      year: '',
      make: '',
      model: '',
      engine: '',
    },
    customer: {
      customerId: null,
      phone: null,
      email: null,
      fullName: null,
      companyName: null,
      contactOnPhone: false,
      contactOnEmail: false,
    },
    estimate: {
      estimateId: null,
      title: null,
      code: null,
    },
    vehicles: [],
    notes: null,
    switch: {
      confirmation: true,
      reminders: true,
    },
    accordion: {
      confirmation: false,
      manualCancelled: false,
      reminders: false,
    },
    type: '',
  };
  defaultTemplates: any = {
    confirmation: {
      subject: '',
      contents: '',
    },
    confirmReply: {
      subject: '',
      contents: '',
    },
    cancelReply: {
      subject: '',
      contents: '',
    },
    reminder: {
      subject: '',
      contents: '',
    },
    reschedule: {
      subject: '',
      contents: '',
    },
  };
  templates: any = {
    confirmation: {
      subject: '',
      contents: '',
    },
    confirmReply: {
      subject: '',
      contents: '',
    },
    cancelReply: {
      subject: '',
      contents: '',
    },
    reminder: {
      subject: '',
      contents: '',
    },
    reschedule: {
      subject: '',
      contents: '',
    },
  };
  acFocus: any = {
    calendar: false,
    customer: false,
    vehicle: false,
    estimate: false,
    user: false,
    note: false,
    concern: false,
  };
  focusConcern: any[] = [{ concern: false }];
  acFocusLabel: any = {
    customer: 'Customer',
    vehicle: 'Vehicle',
    estimate: 'Estimate',
    user: 'Technician',
    note: 'Notes',
  };
  acNotDisable: any = {
    customer: true,
    estimate: true,
  };
  validate: any = {};
  technician: any[] = [];
  selectedTechnician: any = [];
  sideAccordionVisible: boolean = false;
  navigateToEstimate: boolean = false;
  defaultTechnicianId: string = '';
  param: any = {};
  duration: any = 60;
  confirmationTagsArray = [];
  isUpdate: boolean = false;
  appointmentStatus: string = '';
  url: string = '';
  disabled: any = {
    customer: false,
    vehicle: false,
  };
  isPastAppointment: boolean = false;
  customer: any = {};
  company: any = {};
  previousCustomerName: string = '';
  previousTitle: string = '';
  confirmationTemplate: any = {};
  reminderTemplate: any = {};
  rescheduleTemplate: any = {};
  currentDateTime: any = '';
  isCustomerFocused: boolean = false;
  isMarketingEnabled: boolean = false;
  isCustomerConcernEnabled: boolean = false;
  templateKeys = {
    APPT_REMINDER: 'reminder',
    APPT_REPLY_CONFIRM: 'confirmReply',
    APPT_REPLY_CANCEL: 'cancelReply',
    APPT_CONFIRMATION: 'confirmation',
    APPT_RESCHEDULE: 'reschedule',
    APPT_CANCEL: 'cancel',
  };
  dataServiceListeners: any[] = [];
  noLicense: string = config.noLicense;
  noVIN: string = config.noVIN;
  isLoading: boolean = false;
  useConfirmationRecipient: boolean = true;
  recipients = {
    emails: [],
    phones: [],
  };
  reminderRecipients = {
    emails: [],
    phones: [],
  };
  confirmationRecipientTooltip: string = '';
  reminderRecipientTooltip: string = '';
  appointmentStatusTooltip: string = '';
  statusTooltip: string = '';
  sourceCampaigns: any = { followUps: [], promotionalCampaigns: [], leadCampaigns: [] };
  campignSuggestions: any = [];
  appointmentRequest: any = null;
  appointmentTab: boolean = true;
  blockTab: boolean = false;
  blockAppointment: any = {};
  hideAppointmentTab = false;
  isApptRequestPortalEnabled: any;
  timeWhenAppointmentCreated: any = {};
  initialRescheduleReq = false;
  timezones: any = {};
  index: number = 0;
  defaultAppointmentStatus: string = '';
  concern: any = [{ notes: '', index: 1 }];
  customerConfirmation: boolean = false;
  hasConcernedNotes: boolean = false;
  expanded: boolean = false;
  allConcerns: any[] = [{ notes: '', services: [], isUpdated: true }];
  errorsConcern = [];
  isDvi2Enabled: boolean = false;
  selectedStartDate: string = '';
  selectedEndDate: string = '';
  formatBlockedTimes: any = [];
  currentLang: string = 'en';
  companyLocalization: boolean = false;
  languageTemplates: any = [];
  isLanguageDropdownVisible: boolean = false;
  tireStorageInspectionIcons: any = {
    missing: 'assets/img/icon/tire-storage-fill-red.svg',
    completed: 'assets/img/icon/tire-storage-fill-green.svg',
    nostoredtires: 'assets/img/icon/ts-grayed-icon.svg',
  };

  tireStorageInspectionStatus: string = 'missing';
  isTireStorage2Enabled: boolean = false;
  isLoadingTirestorageData: boolean = true;
  tireStorages: any[] = [];
  customFleetSettings: any = {};
  isRunTireStorageRoFlow: boolean = false;
  estimateURL: string = '';
  tsCreatedRoId: string = '';
  tireStorageId: string = '';
  tiresInfoCount: number = 0;
  isMarketingNotifEnabled: boolean = false;
  isOperationalNotifEnabled: boolean = false;
  // search pagination
  hasMoreData: boolean = true;
  offset = 0;
  limit: number = 15;
  query: string = '';

  constructor(
    public helperService: HelperService,
    public dref: DynamicDialogRef,
    private httpService: HTTPService,
    private dataService: DataService,
    private dateService: DateService,
    private router: Router,
    private dialogService: DialogService,
  ) { }

  async ngOnInit() {
    setTimeout(() => {
      const dialog = document.querySelectorAll<HTMLElement>('.add-dialog');
      dialog[0].style.zIndex = (Number(dialog[0].style.zIndex) + 999).toString();
    }, 1000);

    const localizationSubscription = this.dataService.getCompanyLocalization().subscribe((value) => {
      if (value) {
        this.companyLocalization = value;
      }
    });
    this.dataServiceListeners.push(localizationSubscription);

    this.isApptRequestPortalEnabled = this.dataService.isApptRequestPortalEnabled;
    this.isCustomerConcernEnabled = this.dataService.isCustomerConcernEnabled;
    this.isTireStorage2Enabled = this.dataService.isTireStorage2Enabled;
    // this.isDvi2Enabled = this.company.appsettings.isDvi2Enabled;

    try {
      await this.initializeAppointment();
    } catch (err) { }

    /** Fetching technicians */
    this.settingListeners();
    this.checkCustomerVehicleUpdate();
    this.getSourceCampaign();
    this.url = this.router.url;
  }

  ngOnChanges(change: any) { }

  ngOnDestroy() {
    this.dataServiceListeners.forEach((listener) => {
      try {
        listener.unsubscribe();
      } catch (err) { }
    });
  }

  async getBlockedAvailabilities() {
    let conf = {
      search: '',
      startDate: this.selectedStartDate,
      endDate: this.selectedEndDate,
      dateOrder: 'desc',
      sortOrder: 1,
      limit: 20,
      skip: null,
      status: 'block',
    };

    return await this.httpService.getAppointmentRequest(conf);
  }

  getSourceCampaign() {
    const { customer = {} } = this.appointment;

    if (!customer.customerId) {
      return;
    }

    const data: any = {
      customerId: (customer.customerId && customer.customerId._id) || customer.customerId,
    };

    if (this.appointment._id) {
      data.createdAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(this.currentDateTime).getTime()), datetimeFormat.yyymmddhhmm);
    } else {
      data.createdAt = this.dateService.formatDate(new Date(this.currentDateTime), datetimeFormat.yyymmddhhmm);
    }

    this.httpService.getSourceCampaigns(data).then(
      (campaign: any) => {
        this.httpService.getLeadSource(true, {}).then((leadCampaign) => {
          this.campignSuggestions = [];
          this.sourceCampaigns = {
            followUps: [],
            promotionalCampaigns: [],
            leadCampaigns: [],
          };

          if (campaign && campaign.followUps?.length) {
            campaign.followUps.forEach((followup: any) => {
              followup.sendDate = this.dateService.getCurrentDateTimeTz(new Date(followup.sendDate).getTime()).getTime();
              this.sourceCampaigns.followUps.push(followup);
            });
          }
          if (campaign && campaign.promotionalCampaigns?.length) {
            campaign.promotionalCampaigns.forEach((prom: any) => {
              prom.sendDate = this.dateService.getCurrentDateTimeTz(new Date(prom.sendDate).getTime()).getTime();
              this.sourceCampaigns.promotionalCampaigns.push(prom);
            });
          }

          if (this.dataService.isMarketingEnabled && this.dataService.isMarketingLeadAttributionEnabled) {
            if (leadCampaign && leadCampaign?.length) {
              leadCampaign.forEach((lead: any) => {
                this.sourceCampaigns.leadCampaigns.push(lead);
              });
            }
            this.campignSuggestions = [...this.sourceCampaigns.followUps, ...this.sourceCampaigns.promotionalCampaigns, ...this.sourceCampaigns.leadCampaigns];
          } else {
            this.campignSuggestions = [...this.sourceCampaigns.followUps, ...this.sourceCampaigns.promotionalCampaigns];
          }
        });
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  initializeAppointment() {
    return new Promise((resolve, reject) => {
      this.httpService.getAppointmentInitData().then(
        async ({ technicians, company, templates, serverTime, qboTaxExemptReasons = [], timezones }) => {
          this.company = company;
          this.timezones = timezones;
          this.languageTemplates = templates;

          this.setCompanyData(this.company);
          this.currentDateTime = serverTime;
          this.isMarketingEnabled = this.company.appsettings && this.company.appsettings.isMarketingEnabled;
          this.isDvi2Enabled = this.company.appsettings.isDvi2Enabled;
          if (this.isDvi2Enabled && !this.appointment._id) {
            this.concern[0].concernType = 'customerConcern';
          }

          if (qboTaxExemptReasons && qboTaxExemptReasons?.length) {
            this.setTaxExemptReasons(qboTaxExemptReasons);
          }

          if (this.company.appsettings) {
            const { appointmentColors = [], caledarsettings = [] } = this.company.appsettings;

            if (appointmentColors && appointmentColors?.length) {
              this.setAppointmentColors(appointmentColors);
            } else {
              this.setAppointmentColors(this.helperService.deepCopy(config.colors));
            }

            if (caledarsettings && caledarsettings?.length) {
              this.setBusinessDays(caledarsettings);
            }
          }

          if (!this.isUpdate) {
            if (this.company.appsettings && this.company.appsettings.reminders && this.company.appsettings.reminders?.length && this.company.appsettings.reminders[0].key) {
              this.appointment.reminders = this.helperService.deepCopy(this.company.appsettings.reminders);
            } else {
              this.appointment.reminders = [
                { key: 'h', frequency: 1 },
                { key: 'h', frequency: 2 },
                { key: 'd', frequency: 1 },
              ];
            }
            await this.setDateTimes();
          }
          // do not set default time in case of appointment already exists otherwise the actual appointment time gets override
          //await this.setDateTimes();
          this.populateTemplates(templates);
          this.populateTechnicians();
          this.setDisabledReminders();

          resolve({});
        },
        (err) => {
          this.helperService.showToaster('error', err);
          reject();
        },
      );
    });
  }

  checkCustomerVehicleUpdate() {
    this.dataServiceListeners.push(
      this.dataService.getData().subscribe(({ data }) => {
        if (data.type === 'sidebar' && data.tab === 'close') {
          if (this.appointment.customer && this.appointment.customer.customerId) {
            console.log('Reloading all vehicles');
            this.httpService.getVehiclesByCustomer(this.appointment.customer.customerId).then(
              (records: any) => {
                if (records.vehicles && records.vehicles?.length) {
                  this.appointment.vehicles = records.vehicles.map((veh: any) => {
                    if (this.appointment.vehicle && this.appointment.vehicle.vehicleId === veh._id) {
                      // if (this.appointment.customer && this.appointment.customer.isFleetCustomer && veh.vehicleName) {
                      this.appointment.vehicle.name = veh.vehicleName || veh.name;
                      // } else {
                      //   this.appointment.vehicle.name = veh.name;
                      // }
                    }

                    return {
                      ...veh,
                      vehicleId: veh._id,
                    };
                  });
                  this.appointment.vehicles = sortBy(this.appointment.vehicles, 'name');
                }
              },
              (err) => { },
            );
            this.getCustomerContact();
          }
        }

        if (data.type === 'sidebar' && data.tab === 'close' && data.data) {
          const { customer, vehicle, type } = data.data;
          const apptCustomerId = this.appointment.customer && this.appointment.customer.customerId;
          if (customer && customer._id === apptCustomerId) {
            const updatedCustomer = {
              customerId: customer._id,
              email: customer.email,
              fullName: `${customer.firstName} ${customer.lastName}`,
              displayName: customer.fullNameQBO,
              fullNameQBO: customer.fullNameQBO,
              isFleetCustomer: customer.isFleetCustomer,
              companyName: customer.companyName,
              isEmail: customer.contactOnEmail,
              isSMS: customer.contactOnPhone,
              phone: customer.phone,
              phone2: customer.phone2,
              notes: customer.notes,
              tags: [],
              taxExempt: customer.taxExempt,
              _id: customer._id,
              contactOnEmail: customer.contactOnEmail,
              contactOnPhone: customer.contactOnPhone,
            };

            updatedCustomer.tags = customer.tags.map((tag: any) => ({
              name: tag.name,
              color: tag.color,
              tagId: tag.categoryId,
            }));

            if (!isEqual(updatedCustomer, this.appointment.customer)) {
              this.appointment.customer = updatedCustomer;
              this.customer = updatedCustomer;
              this.customerSearchKey = updatedCustomer.displayName;
              this.setCommunication();
            }
          }
        }
      }),
    );
  }

  toggleLanguageDropdown() {
    this.isLanguageDropdownVisible = !this.isLanguageDropdownVisible;
  }

  switchLanguage(lang: string) {
    this.currentLang = lang;
    this.isLanguageDropdownVisible = false;
    this.toggleLanguageDropdown();
    this.httpService.updateCustomer({ _id: this.appointment.customer.customerId, preferredLanguage: lang.toUpperCase() }).then((res) => {
      this.helperService.showToaster('success', 'Language updated successfully');
    });
    this.populateTemplates(this.languageTemplates);
    this.parseTemplates();
    this.setCurrentCustomerLang.emit(lang);
  }

  getCustomerContact() {
    this.isFetchingContacts = true;
    this.httpService
      .getContactInfo(this.appointment.customer.customerId, false, { contactEntityType: 'customer' })
      .then((contact) => {
        if (contact && contact.contactInfo) {
          const primaryEmail = find(contact.contactInfo, {
            isPrimary: true,
            contactType: 'email',
          });
          const primaryPhone = find(contact.contactInfo, {
            isPrimary: true,
            contactType: 'mobile',
          });

          if (this.appointment.customer) {
            this.appointment.customer.email = (primaryEmail && primaryEmail.value) || '';
            this.appointment.customer.phone = (primaryPhone && primaryPhone.value) || '';
          }

          this.setRecipient(contact.contactInfo);
        }
      })
      .finally(() => {
        this.isFetchingContacts = false;
      });
  }



  async setDateTimes() {
    if (!this.appointment.date.start || !this.appointment.time.start) {
      await this.setDefaultTime();
      this.getTimeDiffrence(this.appointment.time.start);
    } else {
      this.selectedStartDate = this.appointment.date.start ? this.helperService.getDateByFormat(this.appointment.date.start, 'YYYY-MM-DD') : '';
      this.selectedEndDate = this.appointment.date.end ? this.helperService.getDateByFormat(this.appointment.date.end, 'YYYY-MM-DD') : '';
      // await this.setBlockedTimes();
    }
  }

  async setDefaultTime() {
    /** Getting current time according to the timezone */
    const currentDateTimeTz = this.dateService.getCurrentDateTimeTz(this.currentDateTime);

    /** Setting only the start dates for the appointments */
    this.appointment.date = {
      start: currentDateTimeTz,
      end: currentDateTimeTz,
    };

    const currentTime = moment(currentDateTimeTz);
    /** Getting the successor quarter of the hour */
    const currentMinutes = this.dateService.getNearestSuccessorQuarterHour(currentTime.format('mm'));
    const currentHour = currentTime.add(Number(currentMinutes) === 0 ? 1 : 0, 'hour').format('HH');

    /** Setting the start time and end date & time for the appointment */
    for (let i = 0; i < this.allTimes?.length; i++) {
      const t = this.allTimes[i];

      if (t.value === `${currentHour}:${currentMinutes}`) {
        let endTime: any = {};

        if (t.i === 0) {
          endTime = this.allTimes[t.i + 4];
          this.appointment.date.start = new Date(moment(currentDateTimeTz).add(1, 'day').format());
          this.appointment.date.end = new Date(moment(currentDateTimeTz).add(1, 'day').format());
        } else if (t.i >= 92) {
          endTime = this.allTimes[t.i - 92];
          this.appointment.date.end = new Date(moment(currentDateTimeTz).add(1, 'day').format());
        } else {
          endTime = this.allTimes[t.i + 4];
        }

        this.appointment.time = {
          start: t.value,
          end: endTime.value,
        };
        this.selectedTime = {
          start: t,
          end: endTime,
        };
        // if (this.appointment.date.start && this.appointment.date.end) {
        //   this.selectedStartDate = this.appointment.date.start ? this.helperService.getDateByFormat(this.appointment.date.start, 'YYYY-MM-DD') : '';
        //   this.selectedEndDate = this.appointment.date.end ? this.helperService.getDateByFormat(this.appointment.date.end, 'YYYY-MM-DD') : '';
        //   await this.setBlockedTimes();
        // }
        // const startTimeInNum = Number(t?.value?.split(':')?.join('.'));
        // const endTimeInNum = Number(endTime?.value?.split(':')?.join('.'));
        // const isStartTimeBlocked = this.formatBlockedTimes.some((time) => time[0] <= startTimeInNum && time[1] > startTimeInNum);
        // const isEndTimeBlocked = this.formatBlockedTimes.some((time) => time[0] < endTimeInNum && time[1] >= endTimeInNum);
        // if (!isStartTimeBlocked && !isEndTimeBlocked) {
        //   this.appointment.time = {
        //     start: t.value,
        //     end: endTime.value,
        //   };
        //   this.selectedTime = {
        //     start: t,
        //     end: endTime,
        //   };
        // }
      }
    }

    const selectedTime = localStorage.getItem('startTimePersisted');
    const selectedEndTime = localStorage.getItem('endTimePersisted');

    if (selectedTime) {
      const updatedSelectedTime = this.allTimes.find((item) => item.value === selectedTime);
      this.selectedTime.start = updatedSelectedTime;
    }

    if (selectedEndTime) {
      const updatedSelectedTime = this.allTimes.find((item) => item.value === selectedEndTime);
      this.selectedTime.end = updatedSelectedTime;
    }

    /** Setting the start datetime string in the appointment */
    const { start, end } = this.appointment.date;

    this.appointment.date = {
      start: this.dateService.getDateTimeByDateAndTime(start, this.appointment.time.start),
      end: this.dateService.getDateTimeByDateAndTime(end, this.appointment.time.end),
    };

    if (this.appointment.date.start && this.appointment.date.end) {
      this.selectedStartDate = this.appointment.date.start ? this.helperService.getDateByFormat(this.appointment.date.start, 'YYYY-MM-DD') : '';
      this.selectedEndDate = this.appointment.date.end ? this.helperService.getDateByFormat(this.appointment.date.end, 'YYYY-MM-DD') : '';
      // await this.setBlockedTimes();
    }
  }

  setDataAfterTireStorageReturn(estimateData: any, concernText: string) {
    if (estimateData?._id) {
      this.isRunTireStorageRoFlow = true;
      this.tsCreatedRoId = estimateData?._id;
      this.estimateSearch('', false, estimateData._id);
      const index = findIndex(this.concern, (item: any) => {
        return !item?.notes;
      });
      if (index > -1) {
        this.onFocusInput('concern', index);
        this.concernChange(concernText, null, index);
      }
    }
  }

  settingListeners() {
    /**
     * This subscribe is called from the following
     *
     * add-dialog.component
     */
    this.dataServiceListeners.push(
      this.dataService.getData().subscribe((obj) => {
        const data = obj.data;

        if (data.key === 'company-appdata-updated') {
          this.isApptRequestPortalEnabled = this.dataService.isApptRequestPortalEnabled;
        }

        if (data.key === 'tire-storage-ro-schedule-return') {
          const { estimateData, concernText, estimateURL, tireStorageId } = data?.data;
          this.estimateURL = estimateURL;
          this.tireStorageId = tireStorageId;
          this.setDataAfterTireStorageReturn(estimateData, concernText);
        }

        if (data.key === 'refresh-after-color-update') {
          this.initializeAppointment();
        }
        if (data.type === 'passdata' && data.key === 'appointment-title') {
          const { confirmationSubject, confirmationContent, manualCancelContent, manualConfirmContent, reminderContent } = this.revertTemplateParsing(
            this.templates.confirmation.subject,
            this.templates.confirmation.contents,
            this.templates.cancelReply.contents,
            this.templates.confirmReply.contents,
            this.templates.reminder.contents,
          );
          this.templates.confirmation.subject = confirmationSubject;
          this.templates.confirmation.contents = confirmationContent;
          this.templates.cancelReply.contents = manualCancelContent;
          this.templates.confirmReply.contents = manualConfirmContent;
          this.templates.reminder.contents = reminderContent;
          this.appointment.title = data.data;
          this.parseTemplates();
        }

        if (data.type === 'passdata' && data.key === 'appointment-color') {
          this.appointment.color = data.data;
        }

        if (data.type === 'passdata' && data.key === 'clear-search-data') {
          if (this.appointment && this.appointment.customer && !this.appointment.customer.customerId) {
            this.customerSearchKey = null;
          }
        }
        if (data && data.component === 'delete-request' && this.appointment && this.appointment.appointmentRequests) {
          this.deleteAppointmentRequest();
        }
      }),
    );
  }

  setEditableContainerContent() {
    const confirmationContent = this.templates.confirmation.contents;
    const reminderContent = this.templates.reminder.contents;
    const manualCancelContent = this.templates.cancelReply && this.templates.cancelReply.contents;
    const manualConfirmContent = this.templates.confirmReply && this.templates.confirmReply.contents;

    if (this.confirmationContentEl?.nativeElement) {
      this.confirmationContentEl.nativeElement.innerHTML = confirmationContent;
    }

    if (this.reminderContentEl?.nativeElement) {
      this.reminderContentEl.nativeElement.innerHTML = reminderContent;
    }

    // Manual confirmation feature
    if (this.manualConfirmationContentEl?.nativeElement) {
      this.manualConfirmationContentEl.nativeElement.innerHTML = manualConfirmContent;
    }

    if (this.manualCanceledContentEl?.nativeElement) {
      this.manualCanceledContentEl.nativeElement.innerHTML = manualCancelContent;
    }
    this._initialTemplates = this.helperService.deepCopy(this.templates);
  }

  setBusinessDays(calendarSettings: any[]) {
    const businessDays = {};

    calendarSettings.map((setting: any) => {
      businessDays[calendarDayNumberMap[setting.day]] = setting;
    });

    this.businessDays = businessDays;
  }

  getCustomerForAppointment(customerId: string, isCreatedForOther: boolean = false) {
    this.httpService.getCustomer(customerId, { fetchVehicles: true, populateContact: true }).then(
      (customer: any) => {
        const preSelect = !(this.appointment && this.appointment.customer && this.appointment.customer.customerId);
        this.customer = {
          _id: customer._id,
          customerId: customer._id,
          fullName: `${customer.firstName} ${customer.lastName}`,
          displayName: customer.fullNameQBO,
          fullNameQBO: customer.fullNameQBO,
          isFleetCustomer: customer.isFleetCustomer,
          companyName: customer.companyName,
          email: customer.email,
          tags: customer.tags,
          phone: customer.phone,
          phone2: customer.phone2,
          notes: customer.notes,
          preferredLocation: customer.preferredLocation,
          isMFCustomer: customer.isMFCustomer,
        };
        if (customer.preferredLanguage) {
          this.currentLang = customer.preferredLanguage || 'en';
          this.populateTemplates(this.languageTemplates);
          this.parseTemplates();
          this.setCurrentCustomerLang.emit(this.currentLang);
        }
        if (!isCreatedForOther) {
          this.customer.contactOnEmail = customer.contactOnEmail;
          this.customer.contactOnPhone = customer.contactOnPhone;
        } else if (this.appointment && this.appointment.customer) {
          this.customer.contactOnEmail = this.appointment.customer.contactOnEmail;
          this.customer.contactOnPhone = this.appointment.customer.contactOnPhone;
        }

        this.appointment.switch.confirmation = this.customer.contactOnEmail || this.customer.contactOnPhone;
        this.appointment.switch.reminders = this.customer.contactOnEmail || this.customer.contactOnPhone;

        this.customerSearchKey = this.customer.displayName;
        this.appointment.customer = { ...this.customer };
        this.appointment.vehicles = customer.vehicles || [];

        if (!this.appointment.title) {
          this.appointment.title = this.customer.displayName;
        }

        if (customer.vehicles && customer.vehicles) {
          this.appointment.vehicles.forEach((vehicle: any, index: number) => {
            if (vehicle.vehicleId && vehicle.vehicleId._id) {
              this.appointment.vehicles[index] = vehicle.vehicleId;
              this.appointment.vehicles[index].vehicleId = vehicle._id;
              this.appointment.vehicles[index].name = vehicle.vehicleName || vehicle.name;
            }
          });
        }

        this.useConfirmationRecipient = true;
        this.setRecipient((customer.contactId && customer.contactId.contactInfo) || []);

        this.setColor();
        this.acFocus.vehicle = true;
        this.sideAccordionVisible = true;
        this.setCommunication();
        this.parseTemplates();

        if (this.appointment.vehicles?.length && !this.appointment.vehicle.name) {
          const appointment = this.appointment.vehicles[this.appointment.vehicles?.length - 1];
          if (appointment && appointment.isActive) {
            this.onSelectVehicle(appointment);
          } else {
            this.focus.vehicle = true;
          }
        } else {
          this.focus.vehicle = true;
        }

        if (customer.vehicles && customer.vehicles) {
          this.appointment.vehicles = sortBy(this.appointment.vehicles, 'name');
        }

        // this.estimateSearch('', preSelect);
        this.estimateSearch('', false); // uncommit this to preselect RO
        this.appointmentTitleUpdate();
        this.getSourceCampaign();
        this.checkPreferredLocation(customer);
      },
      (err) => {
        this.helperService.showToaster('error', err);
      },
    );
  }

  renderName(name: string) {
    if (name) {
      const [firstName, lastName] = name.split(' ');
      return `${firstName} ${this.helperService.fetchInitials(lastName)}`;
    }

    return '';
  }

  getAppointmentById(appointmentId: string) {
    this.isLogsLoading = true;
    this.httpService
      .getApptLogs(appointmentId)
      .then(
        (activities) => {
          if (activities?.length) {
            this.activities = activities;
            this.activities.forEach((activity) => {
              activity.actionBy = this.renderName(activity.actionBy);
              activity.initial = this.helperService.fetchInitials(activity.actionBy || '') || 'AL';
              activity.createdAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(activity.createdAt).getTime()), datetimeFormat.hhmmaammmdyy);
            });
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isLogsLoading = false;
      });
    this.httpService
      .getAppointmentById(appointmentId)
      .then(
        (appointment) => {
          if (!appointment) return;

          const { reminderRecipients, confirmationRecipients, customer, status, manualConfirm } = appointment;
          const contactMap = {};
          this.defaultAppointmentStatus = status;
          (this.customerConfirmation = manualConfirm),
            setTimeout(() => {
              if (['confirmed', 'cancelled'].includes(status)) {
                this.handleTabChange({ index: 1 });
              }
            }, 500);

          if (customer && customer.customerId && customer.customerId.contactId && customer.customerId.contactId.contactInfo) {
            customer.customerId.contactId.contactInfo.forEach((contact) => {
              contactMap[contact.value] = contact;
            });

            this.httpService.getCustomerPreferredLanguage(customer.customerId._id).then((res) => {
              if (this.companyLocalization) {
                if (res && res.preferredLanguage) {
                  this.currentLang = res.preferredLanguage;
                  this.setCurrentCustomerLang.emit(res.preferredLanguage);
                  this.populateTemplates(this.languageTemplates);
                }
              } else {
                this.currentLang = 'en';
              }
            });
          }

          if (confirmationRecipients && confirmationRecipients?.length) {
            confirmationRecipients.forEach((contact: any) => {
              delete contact.createdAt;
              delete contact.updatedAt;

              let _contact = {
                ...contact,
                _id: contact.recipientId,
              };

              if (contactMap[contact.value]) {
                _contact = { ..._contact, ...contactMap[contact.value] };
              }

              if (contact.type === 'email') {
                this.recipients.emails.push(_contact);
              } else {
                this.recipients.phones.push(_contact);
              }
            });
          }

          if (reminderRecipients && reminderRecipients?.length) {
            reminderRecipients.forEach((contact: any) => {
              delete contact.createdAt;
              delete contact.updatedAt;

              let _contact = {
                ...contact,
                _id: contact.recipientId,
              };

              if (contactMap[contact.value]) {
                _contact = { ..._contact, ...contactMap[contact.value] };
              }

              if (contact.type === 'email') {
                this.reminderRecipients.emails.push(_contact);
              } else {
                this.reminderRecipients.phones.push(_contact);
              }
            });

            this.unsubscriptionTooltip = this.helperService.unsubscriptionReminderTooltip(this.reminderRecipients);
            this.isReminderDisabled = !(
              this.reminderRecipients.emails.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled)?.length +
              this.reminderRecipients.phones.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled)?.length
            );
            this.appointment.switch.reminders = !this.isReminderDisabled;
            this.appointment.switch.confirmation = !this.isReminderDisabled;
          }

          this.confirmationRecipientTooltip = this.helperService.createContactTooltip(this.recipients, 'Confirmation');
          this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder', true);
          this.appointmentStatusTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Status');

          this.useConfirmationRecipient = isEqual(this.recipients, this.reminderRecipients);

          let convertedStartDate: any, convertedEndDate: any;

          if (this.helperService.isAppleDevice()) {
            convertedStartDate = new Date(this.dateService.madeDateStringIOSCompatible(appointment.start));
            convertedEndDate = new Date(this.dateService.madeDateStringIOSCompatible(appointment.end));
          } else {
            convertedStartDate = new Date(appointment.start);
            convertedEndDate = new Date(appointment.end);
          }

          const start: any = this.helperService.convertDate(convertedStartDate);
          const end: any = this.helperService.convertDate(convertedEndDate);

          this.selectedStartDate = start.toDate() ? this.helperService.getDateByFormat(start.toDate(), 'YYYY-MM-DD') : '';
          this.selectedEndDate = end.toDate() ? this.helperService.getDateByFormat(end.toDate(), 'YYYY-MM-DD') : '';
          // this.setBlockedTimes();
          this.duration = (new Date(end).getTime() - new Date(start).getTime()) / 60000;
          /** Populating appointments and date time */
          this.oldappointment = this.helperService.deepCopy(appointment);
          this.appointment = {
            ...this.helperService.deepCopy(appointment),
            date: {
              start: start.toDate(),
              end: end.toDate(),
            },
            time: {
              start: `${start.format('HH')}:${start.format('mm')}`,
              end: `${end.format('HH')}:${end.format('mm')}`,
            },
            switch: {
              reminders: false,
              confirmation: false,
            },
            accordion: {
              reminders: false,
              confirmation: false,
              manualCancelled: false,
            },
            color: appointment.color,
          };
          this.setSelectedTime();
          this.appointmentStatus = appointment.status || '';

          /** Populating customer data */
          if (appointment.customer && appointment.customer.customerId) {
            this.customer = { ...appointment.customer.customerId };
            this.customer.customerId = this.customer._id;
            this.customer.fullName = `${this.customer.firstName} ${this.customer.lastName}`;
            this.customer.contactOnPhone = appointment.isSMS;
            this.customer.contactOnEmail = appointment.isEmail;

            if (this.customer.contactId && this.customer.contactId.contactInfo) {
              this.customer.contacts = this.customer.contactId.contactInfo;
              this.appointment.customer.contacts = this.customer.contacts;
            }

            this.appointment.customer.fullName = this.customer.fullName;
            this.appointment.customer.fullNameQBO = this.customer.fullNameQBO;
            this.appointment.customer.notes = this.customer.notes;
            this.appointment.vehicles = appointment.vehicles || [];
            this.appointment.customer.customerId = this.customer.customerId;
            this.appointment.customer._id = this.customer.customerId;
            this.customerSearchKey = this.customer.fullNameQBO;
            this.appointment.customer.contactOnPhone = appointment.isSMS;
            this.appointment.customer.contactOnEmail = appointment.isEmail;
            this.estimateSearch('', false);
          }

          /** Populating vehicle data */
          if (appointment.vehicle && appointment.vehicle.vehicleId) {
            const vehicle = appointment.vehicle.vehicleId;
            this.appointment.vehicle.vehicleId = vehicle._id;
            this.appointment.vehicle.engine = vehicle.engine;
            this.appointment.vehicle.year = vehicle.year;
            this.appointment.vehicle.make = vehicle.make;
            this.appointment.vehicle.model = vehicle.model;
            this.appointment.vehicle.name = appointment.vehicle.name;
            this.selectedVehicle = { ...this.appointment.vehicle };
          }

          /** Populating order */
          if (appointment.estimate && appointment.estimate.estimateId) {
            const estimate = appointment.estimate.estimateId;
            this.appointment.estimate = {
              ...estimate,
              estimateId: estimate._id,
            };
            const estimateVehicle = appointment.estimate.estimateId.vehicle;
            this.estimateSearchKey = `${estimate.title || 'Untitled'} - ${estimate.code}`;
            this.estimateVehicleId = estimateVehicle && estimateVehicle.vehicleId;
          }

          /** Populating technicians */
          if (appointment.techs?.length > 0) {
            if (this.technician?.length) {
              this.checkSelectedTechnician(appointment.techs);
            }

            this.appointment.selectedTechs = appointment.techs;
          }

          /** Confirm Email and Reminders text */
          if (appointment.reminderText) {
            const startTime = this.allTimes.filter((t) => t.value === this.appointment.time.start)[0];
            const endTime = this.allTimes.filter((t) => t.value === this.appointment.time.end)[0];
            const data = {
              customer: this.appointment.customer,
              company: this.company,
              vehicle: this.appointment.vehicle,
              appointment: {
                startDate: this.dateService.formatDate(this.appointment.date.start, datetimeFormat.dmmmyy),
                startTime: startTime && startTime.label,
                endDate: this.dateService.formatDate(this.appointment.date.end, datetimeFormat.dmmmyy),
                endTime: endTime && endTime.label,
              },
            };

            this.templates.confirmation = this.helperService.deepCopy(this.templates.reschedule);
            this.appointment.switch.reminders = !!appointment.reminders?.length;

            if (!appointment.reminders?.length) {
              this.appointment.reminders = [{ key: 'h', frequency: 1 }];
            }
          } else {
            this.appointment.switch.reminders = false;
          }

          if (appointment.confirmationText) {
            this.templates.confirmation.contents = appointment.confirmationText;
          }

          if (appointment.followUpCampaign && appointment.followUpCampaign.campaignId) {
            this.appointment.followUpCampaign = appointment.followUpCampaign;
            this.sourceCampaign = appointment.followUpCampaign;
          } else if (appointment.marketingCampaign && appointment.marketingCampaign.marketingCampaignId) {
            this.appointment.followUpCampaign = appointment.marketingCampaign;
            this.sourceCampaign = appointment.marketingCampaign;
          } else if (appointment.leadCampaign && appointment.leadCampaign.leadCampaignId) {
            this.appointment.leadCampaign = appointment.leadCampaign;
            this.sourceCampaign = appointment.leadCampaign;
          }

          this.appointment.switch = {
            confirmation: appointment.isConfirmationOn,
            reminders: appointment.isReminderOn,
          };

          this.sideAccordionVisible = true;
          this.appointmentTitleUpdate();
          this.setCommunication();
          this.parseTemplates();
          this.setDisabledReminders();
          // this.getAppointmentRequestById();
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.getTireStorageData(this.appointment?.customer?.customerId || this.appointment?.customer?._id, this.appointment?.vehicle?.vehicleId);
      });
    if (this.estimateId) {
      this.httpService.getOrderConcerns({ apptId: appointmentId }).then((concern) => {
        if (concern?.length) {
          this.concern = concern.sort((a, b) => a.index - b.index);
        }
      });
    } else {
      this.httpService.getOrderConcerns({ apptId: appointmentId }).then((concern) => {
        if (concern?.length) {
          this.concern = concern.sort((a, b) => a.index - b.index);
        }
      });
    }
  }

  /** Populating technicians */
  populateTechnicians() {
    this.httpService
      .getAppState({
        module: 'calendar',
        fetchTechs: 'true',
      })
      .then(
        ({ techs }: any) => {
          this.technician = [];
          techs.forEach((tech: any) => {
            if (tech.role === 'tech' || tech.isWorkAsTechEnabled) {
              const technician = {
                _id: tech._id,
                label: `${tech.firstName} ${tech.lastName}`,
                value: {
                  techId: tech._id,
                  name: `${tech.firstName} ${tech.lastName}`,
                },
                initials: tech.initials,
              };

              this.technician.push(technician);
            }
          });
          this.technician.sort((a, b) => a.label.localeCompare(b.label));
          if (this.defaultTechnicianId) {
            this.checkSelectedTechnician([{ techId: this.defaultTechnicianId }]);
          } else {
            this.checkSelectedTechnician(this.appointment.selectedTechs);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
  }

  setDisabledReminders() {
    const periodType = {
      d: 'days',
      w: 'weeks',
      h: 'hours',
    };

    if (this.appointment.reminders && this.appointment.reminders?.length && this.appointment.date && this.appointment.time) {
      const startDateTime = this.dateService.getDateTimeByDateAndTime(this.appointment.date.start, this.appointment.time.start);
      this.appointment.reminders.forEach((reminder: any) => {
        const { key, frequency } = reminder;
        if (key && frequency) {
          const reminderTime = this.dateService.subtractPeriodFromDate(frequency, periodType[key], startDateTime).toDate();
          let currentDateTimeTz: any = new Date(this.dateService.getCurrentDateTimeTz(this.currentDateTime)).getTime();
          if (reminderTime > currentDateTimeTz) {
            reminder.isActive = true;
          } else {
            reminder.isActive = false;
          }
        }
      });
    }
  }

  /** Populating all templates */
  populateTemplates(templates: any[]) {
    templates.forEach((template) => {
      if (!this.companyLocalization) this.currentLang = 'en';
      if (template.language === this.currentLang.toUpperCase()) {
        template.contents = template.contents.replace(/\n\n/g, '  <br>');
        template.contents = template.contents.replace(new RegExp('\\[appointment_title\\]', 'g'), '<appt>[appointment_title]</appt>');
        const templateKey = this.templateKeys[template.type];
        if (template && template._id) {
          this.templates[templateKey] = template;
          this.defaultTemplates[templateKey] = this.helperService.deepCopy(template);
        }
      }
    });

    if (this.appointment && this.appointment._id) {
      this.templates.confirmation = this.templates.reschedule;
    }
  }

  setCommunication() {
    this.isPastAppointment = this.checkForPreviousAppt();
  }

  async setSelectedTime() {
    if (this.timeWhenAppointmentCreated && this.timeWhenAppointmentCreated.time && this.timeWhenAppointmentCreated.time.start) {
      this.appointment.time = this.timeWhenAppointmentCreated.time;
    }

    this.selectedStartDate = this.appointment.date.start ? this.helperService.getDateByFormat(this.appointment.date.start, 'YYYY-MM-DD') : '';
    this.selectedEndDate = this.appointment.date.end ? this.helperService.getDateByFormat(this.appointment.date.end, 'YYYY-MM-DD') : '';
    // await this.setBlockedTimes();
    const startTimeInNum = Number(this.appointment?.time?.start?.split(':')?.join('.'));
    const endTimeInNum = Number(this.appointment?.time?.end?.split(':')?.join('.'));
    const isStartTimeBlocked = this.formatBlockedTimes.some((time) => time[0] <= startTimeInNum && time[1] > startTimeInNum);
    // if (isStartTimeBlocked) {
    //   this.appointment.time.start = null;
    //   this.selectedTime.start = null;
    // }
    const isEndTimeBlocked = this.formatBlockedTimes.some((time) => time[0] < endTimeInNum && time[1] >= endTimeInNum);
    // if (isEndTimeBlocked) {
    //   this.appointment.time.end = null;
    //   this.selectedTime.end = null;
    // }
    this.getTimeDiffrence(this.appointment.time.start);
    const selectedTime = localStorage.getItem('startTimePersisted');
    const selectedEndTime = localStorage.getItem('endTimePersisted');

    for (let i = 0; i < this.allTimes?.length; i++) {
      const t = this.allTimes[i];
      if ((selectedTime && t.value === selectedTime) || (!selectedTime && t.value === this.appointment.time.start)) {
        // if (!isStartTimeBlocked) {
          this.selectedTime.start = t;
        // }
      }
      if ((selectedEndTime && t.value === selectedEndTime) || (!selectedEndTime && t.value === this.appointment.time.end)) {
        // if (!isEndTimeBlocked) {
          this.selectedTime.end = t;
        // }
      }
    }
  }

  setColor(dafault = true) {
    // if (dafault) {
    // we always want to show primary color by default
    // this.appointment.color = config.defaultPrimary;
    // }

    /**
     * This data is subscribe in appointment-add.component
     */
    this.dataService.sendData(this.dataService.typePassData('appointment-color', this.appointment.color));
  }

  toggleAddReminder() {
    this.isAddReminderOpen = !this.isAddReminderOpen;
    if (this.isAddReminderOpen) {
      this.appointment.accordion['reminders'] = false;
    }
  }

  toggleActiveState(key: string, status: boolean) {
    this.appointment.switch[key] = status;
  }

  toggleAccordianState(key: string, event: any) {
    event.stopPropagation();
    this.appointment.accordion[key] = !this.appointment.accordion[key];
    this.parseTemplates();

    if (key === 'reminders') {
      if (this.appointment.accordion[key]) {
        this.isAddReminderOpen = false;
      }
    }
    this.parseTemplates();
  }

  checkSelectedTechnician(technicians: any[]) {
    if (!technicians) {
      return;
    }

    this.selectedTechnician = [];
    const technicianIds = technicians.map(({ techId }) => techId);

    this.technician.forEach((tech: any) => {
      if (technicianIds.indexOf(tech._id) !== -1) {
        tech.isChecked = true;
        this.selectedTechnician.push({
          label: tech.label,
          _id: tech._id,
          value: tech,
        });
      }
    });
  }

  showSuggestions(autocomplete: any, type: any) {
    setTimeout(() => {
      this.acFocus[type] = true;
    }, 100);
    if (type === 'customer') {
      this.customerSearchResults = [];
      this.customerSearchResults.push({ _id: 'new-customer' });
    } else if (type === 'estimate') {
      this.estimateSearchResults = [];
      this.estimateSearchResults.push({ _id: 'new-estimate' });
    }
    autocomplete.show();
  }

  handleScroll() {
    this.offset += this.limit;
    this.customerSearch();
  }

  customerSearch(query: string = '', defaultSearch?) {
    if (!this.hasMoreData) {
      return;
    }
    if (query) {
      this.query = query;
      this.limit = 15;
      this.offset = 0;
    }
    let conf = {
      limit: this.limit,
      skip: this.offset,
      search: this.query.trim(),
    };

    let hasScrollAlready = +40;
    this.httpService.searchCustomer(this.query.trim(), { ...conf, populateContact: true, populateVehicles: false, populatePricing: true, populateTaxCodeOverRide: true, }).then(
      (customer: any[]) => {

        if (defaultSearch) {
          this.defaultCustomerSearch = [...this.defaultCustomerSearch, ...customer];
        } else {
          this.customerSearchResults = [...this.customerSearchResults, ...customer];
        }
        if (this.customerSearchResults?.length > 0) {
          this.isLoading = false;
        }
        this.isLoading = false;
        this.scrollToTop(hasScrollAlready);

        if (this.customerSearchResults.length < this.limit) {
          this.hasMoreData = false;
        }
      },
      (err) => {
        this.isLoading = false;
        this.helperService.showToaster('error', err);
      },
    );
  }

  vehicleSearch(search: string) {
    if (this.appointment.customer && this.appointment.customer.customerId) {
      this.isLoading = true;
      this.vehicleType = { active: [], inactive: [] };
      this.httpService
        .getCustomerVehicle(this.appointment.customer.customerId, {
          fetchTags: false,
          needPagination: true,
          search,
          limit: 15,
        })
        .then(
          ({ vehicles }: any) => {
            if (vehicles && vehicles?.length >= 0) {
              vehicles.forEach((vehicle: any, index: number) => {
                // if (this.appointment.customer.isFleetCustomer) {
                if (vehicle.vehicleName) {
                  vehicles[index].name = vehicle.vehicleName;
                }
                if (vehicle.isActive) {
                  this.vehicleType.active.push(vehicle);
                } else {
                  this.vehicleType.inactive.push(vehicle);
                }
                // }
              });

              // vehicles = sortBy(vehicles, 'name');
              this.vehicleSearchResults = vehicles;
            }
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        )
        .finally(() => {
          this.isLoading = false;
        });
    }
  }

  /* Only called when customer changes search text for customer search */
  onCustomerSearchChange(event: any) {
    this.customerSearchData = event;
    this.query = event;
    this.limit = 15;
    this.offset = 0;
    this.hasMoreData = true;
    this.defaultCustomerSearch = [];
    this.customerSearchResults = []
  }

  onSearchClear(event?: any) {
    this.limit = 15;
    this.offset = 0;
    this.hasMoreData = true;
    this.query = '';
    this.isLoading = false;
    this.templates.confirmation.subject = this.defaultTemplates.confirmation.subject;
    this.templates.confirmation.contents = this.defaultTemplates.confirmation.contents;
    this.templates.reminder.contents = this.defaultTemplates.reminder.contents;
    this.setEditableContainerContent();
    this.customerSearchResults = [];
    this.appointment.title = '';

    this.validate['customer'] = '';
    this.customerSearchKey = null;
    this.acFocusLabel.customer = 'Customer';
    this.appointment.customer.customerId = null;
    this.appointment.customer.phone = null;
    this.appointment.customer.phone2 = null;
    this.appointment.customer.email = null;
    this.appointment.customer.displayName = null;
    this.appointment.customer.notes = null;
    this.appointment.customer.fullName = null;
    this.appointment.customer.contactOnPhone = false;
    this.appointment.customer.contactOnEmail = false;
    this.recipients = {
      emails: [],
      phones: [],
    };
    this.reminderRecipients = {
      emails: [],
      phones: [],
    };
    this.confirmationRecipientTooltip = '';
    this.reminderRecipientTooltip = '';
    this.setColor(false);

    this.appointment.vehicles = [];
    this.customerSearchResults = [];

    this.templates = {
      confirmation: {
        subject: '',
        contents: '',
      },
      confirmReply: {
        contents: '',
      },
      cancelReply: {
        contents: '',
      },
      reminder: {
        contents: '',
      },
    };

    this.acFocus.vehicle = false;
    this.appointment.switch.confirmation = false;
    this.appointment.switch.reminders = false;
    this.sideAccordionVisible = false;
  }

  setCustomFleetSettings(customer: any, estimate?: any) {
    this.customFleetSettings = {};
    if (this.isTireStorage2Enabled && customer.isFleetCustomer) {
      this.customFleetSettings = {
        isOrderDiscOverride: customer.isOrderDiscOverride,
        isShopSuppliesOverride: customer.isShopSuppliesOverride,
        isLaborRateOverride: customer.isLaborRateOverride,
        isPricingMatrixOverride: customer.isPricingMatrixOverride,
        isTaxCodeOverride: customer.isTaxCodeOverride,
        customLaborRate: customer.customLaborRate,
        customPartPricingMatrix: customer.customPartPricingMatrix,
        customTirePricingMatrix: customer.customTirePricingMatrix,
        customOrderDiscount: customer.customOrderDiscount,
        customShopSupplies: customer.customShopSupplies,
        customTaxCode: customer.customTaxCode,
        isFleetCustomer: customer?.isFleetCustomer,
      };

      const { customPartPricingMatrix, customTirePricingMatrix, customLaborRate, isShopSuppliesOverride, customShopSupplies } = this.customFleetSettings;

      if (isShopSuppliesOverride && estimate && estimate?.isShopFeeEnabled) {
        this.customFleetSettings.customShopSupplies = customShopSupplies;
      }

      if (customPartPricingMatrix && customPartPricingMatrix._id && !customPartPricingMatrix.pricingId) {
        this.customFleetSettings.customPartPricingMatrix.pricingId = customPartPricingMatrix._id;
      }
      if (customTirePricingMatrix && customTirePricingMatrix._id && !customTirePricingMatrix.pricingId) {
        this.customFleetSettings.customTirePricingMatrix.pricingId = customTirePricingMatrix._id;
      }
      if (customLaborRate && customLaborRate._id && !customLaborRate.pricingId) {
        this.customFleetSettings.customLaborRate.pricingId = customLaborRate._id;
      }
    }
  }

  onSearchSelect(customer: any) {
    if (!customer.isActive) {
      return;
    }

    this.httpService.getCustomerPreferredLanguage(customer._id).then((res) => {
      if (this.companyLocalization) {
        if (res && res.preferredLanguage) {
          this.currentLang = res.preferredLanguage;
          this.populateTemplates(this.languageTemplates);
        }
      } else {
        this.currentLang = 'en';
      }
    });
    // Setting appointment title on customer selection
    if (this.appointment.title && this.previousCustomerName) {
      this.appointment.title = this.appointment.title.replace(this.previousCustomerName, customer.fullNameQBO);
    } else if (!this.appointment.title) {
      this.appointment.title = customer.fullNameQBO;
    }

    // Setting default data & reverting the parsing
    this.previousCustomerName = customer.fullNameQBO;
    this.customerSearchResults = [];
    this.templates = {
      confirmation: {
        subject: this.defaultTemplates.confirmation.subject,
        contents: this.defaultTemplates.confirmation.contents,
      },
      confirmReply: {
        contents: this.defaultTemplates.confirmReply.contents,
      },
      cancelReply: {
        contents: this.defaultTemplates.cancelReply.contents,
      },
      reminder: {
        contents: this.defaultTemplates.reminder.contents,
      },
    };

    if (this.appointment.customer && this.appointment.customer.fullName) {
      const newTemplate = this.revertTemplateParsing(
        this.templates.confirmation.subject,
        this.templates.confirmation.contents,
        this.templates.cancelReply.contents,
        this.templates.confirmReply.contents,
        this.templates.reminder.contents,
      );

      this.templates.confirmation.subject = newTemplate.confirmationSubject;
      this.templates.confirmation.contents = newTemplate.confirmationContent;
      this.templates.confirmReply.contents = newTemplate.manualConfirmContent;
      this.templates.cancelReply.contents = newTemplate.manualCancelContent;
      this.templates.reminder.contents = newTemplate.reminderContent;
      this.customerSearchResults = [];
    }

    // Select customer
    if (!this.appointmentStatus || ['scheduled', 'confirmed', 'draft'].includes(this.appointmentStatus)) {
      this.validate.customer = '';
      this.customerSearchKey = customer.fullNameQBO;
      this.customer = this.helperService.deepCopy(customer);
      this.appointment.customer = {
        customerId: customer._id,
        fullName: customer.fullName,
        displayName: customer.fullNameQBO,
        fullNameQBO: customer.fullNameQBO,
        isFleetCustomer: customer.isFleetCustomer,
        companyName: customer.companyName,
        email: customer.email,
        phone: customer.phone,
        phone2: customer.phone2,
        tags: customer.tags,
        notes: customer.notes,
        contactOnEmail: customer.contactOnEmail,
        contactOnPhone: customer.contactOnPhone,
        preferredLocation: customer.preferredLocation,
        isMFCustomer: customer.isMFCustomer,
      };
      this.appointment.vehicles = customer.vehicles || [];

      if (this.customer.contactId && this.customer.contactId.contactInfo && this.customer.contactId.contactInfo?.length) {
        this.setRecipient(this.customer.contactId.contactInfo);
      }

      // Formatting vehicles
      if (this.appointment.vehicles?.length) {
        this.appointment.vehicles.forEach((vehicle: any, index: number) => {
          if (vehicle.vehicleId && vehicle.vehicleId._id) {
            this.appointment.vehicles[index] = vehicle.vehicleId;
            this.appointment.vehicles[index].vehicleId = vehicle._id;

            // For fleet customer use vehicleName instead of vehicle name
            // if (customer.isFleetCustomer) {
            if (vehicle.vehicleName) {
              this.appointment.vehicles[index].name = vehicle.vehicleName;
            }
            // }
          }
        });

        this.appointment.vehicles = sortBy(this.appointment.vehicles, 'name');
      }

      this.focus.vehicle = true;

      // Setting color
      if (this.appointment.color === config.defaultColor) {
        this.setColor();
      }

      // Preselecting vehicle and getting estimates for the customer
      if (this.appointment.vehicles?.length) {
        this.estimateSearch('', false); // set the property true to autoselect RO.
      }

      this.sideAccordionVisible = true;
    } else if (this.appointmentStatus === 'cancelled') {
      this.customerSearchKey = customer.fullNameQBO;
      this.appointment.customer.customerId = customer._id;
      this.appointment.customer.fullName = customer.fullName;
      this.appointment.customer.displayName = customer.fullNameQBO;
      this.appointment.customer.fullNameQBO = customer.fullNameQBO;
      this.appointment.customer.isFleetCustomer = customer.isFleetCustomer;
      this.appointment.customer.companyName = customer.companyName;
      this.appointment.customer.email = customer.email;
      this.appointment.customer.phone = customer.phone;
      this.appointment.customer.phone2 = customer.phone2;
      this.appointment.customer.notes = customer.notes;
      this.appointment.customer.tags = customer.tags;
      this.recipients = {
        emails: [],
        phones: [],
      };
      this.reminderRecipients = {
        emails: [],
        phones: [],
      };
      this.confirmationRecipientTooltip = '';
      this.reminderRecipientTooltip = '';

      if (this.appointment.color === config.defaultColor) {
        this.setColor();
      }

      this.appointment.vehicles = customer.vehicles || [];

      if (this.appointment.vehicles?.length) {
        this.appointment.vehicles.forEach((vehicle: any, index: number) => {
          if (customer.isFleetCustomer) {
            if (vehicle.vehicleName) {
              this.appointment.vehicles[index].name = vehicle.vehicleName;
            }
          }
        });

        this.appointment.vehicles = sortBy(this.appointment.vehicles, 'name');
      }

      this.sideAccordionVisible = true;
    } else {
      this.customerSearchKey = '';
    }
    this.setCustomFleetSettings(customer);
    this.getSourceCampaign();
    this.setCommunication();
    this.appointmentTitleUpdate();
    this.parseTemplates();
    this.checkPreferredLocation(customer);
  }

  onSearchSelectMarketing(event: any, close: any = null) {
    this.appointment.removeFollowUpCampaign = true;
    this.appointment.removeMarketingCampaign = true;
    this.appointment.removeLeadCampaign = true;
    this.appointment.followUpCampaign = {};
    this.appointment.marketingCampaign = {};
    this.appointment.leadCampaign = {};
    const payloadSourceCampaign = {
      ...event,
    };
    if (event.parentType === 'followUp') {
      this.appointment.removeFollowUpCampaign = false;
      payloadSourceCampaign['campaignId'] = event._id;
      this.appointment.followUpCampaign = payloadSourceCampaign;
      this.sourceCampaign = payloadSourceCampaign;
    } else if (event.parentType === 'marketingCampaign') {
      this.appointment.removeMarketingCampaign = false;
      payloadSourceCampaign['marketingCampaignId'] = event._id;
      this.appointment.marketingCampaign = payloadSourceCampaign;
      this.sourceCampaign = payloadSourceCampaign;
    } else {
      this.appointment.removeLeadCampaign = false;
      this.sourceCampaign = event;
      this.appointment.leadCampaign = {
        leadCampaignId: event._id,
        title: event.title,
        category: event.category,
      };
    }

    if (close) close();
  }

  clearSourceCampaign(event, campaign) {
    campaign.remove = true;
    if (campaign.campaignId) campaign.parentType = 'followUp';
    if (campaign.marketingCampaignId) campaign.parentType = 'marketingCampaign';

    if (campaign.parentType === 'followUp') {
      if (campaign.remove) this.appointment['removeFollowUpCampaign'] = true;
      this.appointment.followUpCampaign = {};
      this.sourceCampaign = {};
    } else if (campaign.parentType === 'marketingCampaign') {
      if (campaign.remove) this.appointment['removeMarketingCampaign'] = true;
      this.appointment.marketingCampaign = {};
      this.sourceCampaign = {};
    } else {
      if (campaign.remove) this.appointment['removeLeadCampaign'] = true;
      this.appointment.leadCampaign = {};
      this.sourceCampaign = {};
    }
  }

  highlighedItemType(text: string, query: string) {
    // return this.helperService.highlighedItemType(text, query);
  }

  search(query: string) { }

  onSearchClearMarketing() { }

  appointmentTitleUpdate() {
    if (!this.appointment.title) {
      this.appointment.title = this.helperService.apptointmentStaticTitle(this.appointment);
    }
    /**
     * This data is subscribe in appointment-add.component
     */
    this.dataService.sendData(this.dataService.typePassData('appointment-title', this.appointment.title));
  }

  addNewCustomer() {
    this.createCustomer.emit({
      context: 'add-appointment',
      fullName: this.customerSearchData,
      email: this.appointmentRequest ? this.appointmentRequest.customer.email : '',
      phoneNumber: this.appointmentRequest ? this.appointmentRequest.customer.phone : '',
      isMarketingNotifEnabled: this.appointmentRequest ? this.appointmentRequest.isMarketingNotifEnabled : '',
      isOperationalNotifEnabled: this.appointmentRequest ? this.appointmentRequest.isOperationalNotifEnabled : '',
    });
  }

  estimateSearch(event: any, preSelect?: any, tsCreatedRoId?: string) {
    let query = `search=${event.trim()}&vehicle=true&sort=createdAt&order=-1&limit=100&skip=0`;

    if (this.appointment.customer.customerId) {
      let customerId = this.appointment.customer.customerId;

      if (this.appointment.customer.customerId._id) {
        customerId = this.appointment.customer.customerId._id;
      }

      query += `&customerId=${customerId}`;
    }

    if (tsCreatedRoId && this.isTireStorage2Enabled) {
      this.setProcessingState(true);
    }
    this.httpService
      .estimateSearch(query)
      .then(
        (result) => {
          this.estimateSearchResults = result.records;

          if (preSelect) {
            const [estimate] = this.estimateSearchResults;

            if (estimate) {
              if (estimate.customer && estimate.customer.customerId) {
                estimate.customer.contactOnEmail = estimate.customer.customerId.contactOnEmail;
                estimate.customer.contactOnPhone = estimate.customer.customerId.contactOnPhone;
              }

              this.customer = this.helperService.deepCopy(estimate.customer);
              this.onEstimateSelect(estimate, false);
            }
          }

          if (tsCreatedRoId && this.estimateSearchResults?.length) {
            const estimate = find(this.estimateSearchResults, { _id: tsCreatedRoId });
            if (estimate) {
              if (estimate.customer && estimate.customer.customerId) {
                estimate.customer.contactOnEmail = estimate.customer.customerId.contactOnEmail;
                estimate.customer.contactOnPhone = estimate.customer.customerId.contactOnPhone;
              }

              this.customer = this.helperService.deepCopy(estimate.customer);
              this.onEstimateSelect(estimate, false);
            }
          }

          this.scrollToBottom();
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.setProcessingState(false);
      });
  }

  onEstimateClear(clearEstimateList: boolean = true) {
    this.estimateSearchKey = null;
    this.appointment.estimate.estimateId = null;
    this.appointment.estimate.title = null;
    this.appointment.estimate.code = null;
    this.estimateSearchKey = null;
    this.acFocusLabel.estimate = 'Estimate';

    if (clearEstimateList) {
      this.estimateSearchResults = [];
    }
  }

  /**
   * Called when estimate is selected from add RO dropdown
   * @param estimate estimate object that was selected
   * @param setToDisabled
   */
  onEstimateSelect(estimate: any, setToDisabled = true) {
    // check if estimate exist in appointment object, if not create it
    if (!this.appointment.estimate) {
      this.appointment.estimate = {};
    }

    if (this.isTireStorage2Enabled) {
      this.appointment.estimate.isTireScheduleForReturn = estimate?.isTireScheduleForReturn || false;
      const queryParams = {
        browserSessionToken: estimate?.restriction?.token || '',
        checkPreferredLocation: estimate?.checkPreferredLocation || false,
      };

      const url = this.helperService.constructQueryParams(`/estimate/${estimate._id}`, queryParams);
      if (url && estimate?.isTireScheduleForReturn) {
        this.estimateURL = url;
      }
    }

    if (estimate && this.appointment?.estimate) {
      const { _id, title = '', code = '' } = estimate;

      this.appointment.estimate.estimateId = _id;
      this.appointment.estimate.title = title;
      this.appointment.estimate.code = code;

      this.estimateSearchKey = code ? `${title} - ${code}` : title || this.defaultTitle;
      this.acFocusLabel.estimate = title;
    }


    this.appointmentTitleUpdate();

    this.customer = this.helperService.deepCopy(estimate.customer.customerId);
    this.customer.customerId = this.customer._id;
    this.customer.displayName = this.customer.fullNameQBO;
    this.appointment.customer = { ...this.customer };

    if (this.customer && this.customer.contactId && this.customer.contactId.contactInfo && this.customer.contactId.contactInfo?.length) {
      this.useConfirmationRecipient = true;
      this.setRecipient(this.customer.contactId.contactInfo);
    }

    if (this.customer && this.customer._id) {
      this.customerSearchKey = this.customer.fullNameQBO;
      this.sideAccordionVisible = true;
    } else {
      this.customerSearchKey = 'Unassigned Customer';
    }

    if (estimate.vehicle && estimate.vehicle.name) {
      const vehicle = estimate.vehicle.vehicleId;

      if (vehicle) {
        this.appointment.vehicle = {
          vehicleId: vehicle._id,
          make: vehicle.make,
          year: vehicle.year,
          model: vehicle.model,
          vehicle: vehicle.engine,
          name: vehicle.vehicleName || vehicle.name,
        };
        this.estimateVehicleId = vehicle._id;
        this.selectedVehicle = this.appointment.vehicle;
      }
    } else {
      this.selectedVehicle = {};
    }

    if (estimate._id) {
      const estimateId = estimate._id;
      this.estimateId = estimateId;
      this.httpService.getOrderConcerns({ orderId: estimateId }).then((concern) => {
        if (concern?.length) {
          this.concern = [...concern, ...this.concern];
        }
      });
    }

    if (this.appointment && !this.appointment.title) {
      this.appointmentTitleUpdate();
    }

    this.setCommunication();
    this.disabled = {
      customer: setToDisabled,
      vehicle: setToDisabled,
    };
    this.parseTemplates();
  }

  onAddEstimate() {
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: `Create Order`,
        message: 'Save this Appointment and create a new RO',
        button: {
          success: { title: 'Yes' },
          cancel: { title: 'No' },
        },
      },
    });

    const onClose = ref.onClose.subscribe((close: any) => {
      if (close.isSuccess) {
        this.appointment.estimate = {};
        this.appointment.estimate.title = config.defaultTitle;
        this.navigateToEstimate = true;
        this.onSubmit(null, null, true);
      } else {
        this.onEstimateClear(false);
      }
      onClose.unsubscribe();
    });
  }

  openAccordion(type) {
    this.appointment.accordion[type] = !this.appointment.accordion[type];
    for (const property in this.appointment.accordion) {
      if (property !== type) {
        this.appointment.accordion[property] = false;
      }
    }
  }

  handleFocus(type: string) {
    this.focus[type] = true;
  }

  handleRadioChange(type, value) {
    if (type === 'statusConfirm' && value) {
      this.appointment.status = 'confirmed';
    } else if (type === 'statusCancelled' && value) {
      this.appointment.status = 'cancelled';
    }
  }
  handleUseConfirmationRecipientChange(useConfirmationRecipient: boolean) {
    this.useConfirmationRecipient = useConfirmationRecipient;

    if (this.useConfirmationRecipient) {
      this.reminderRecipients = this.helperService.deepCopy(this.recipients);
      this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder', true);
      this.unsubscriptionTooltip = this.helperService.unsubscriptionReminderTooltip(this.reminderRecipients);
      this.isReminderDisabled = !(
        this.reminderRecipients.emails.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled)?.length +
        this.reminderRecipients.phones.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled)?.length
      );
      this.appointment.switch.reminders = !this.isReminderDisabled;
    }
  }

  onFocusInput(type: string, index?) {
    if (type === 'concern') {
      this.focusConcern[index] = { ...this.focusConcern[index], concern: true };
      // this.focusConcern[index].concern = true;
      // this.errorsConcern[index] = { ...this.errorsConcern[index], notes: false };
      // return
    }
    setTimeout(() => {
      this.acFocus[type] = true;
      this.validate['switch'] = '';
      this.validate['time'] = '';
      for (const property in this.acFocus) {
        if (property !== type) {
          this.acFocus[property] = false;
          // this.errorsConcern[index].notes = false;
        }
      }
      this.scrollToBottom();
    }, 100);
  }

  handleBlur(type: string, index?) {
    this.focus[type] = false;

    // if (type === 'customer') { // ZALP-18122-19-NOV-2024
    //   this.isCustomerFocused = false;
    // }

    if (type === 'concern') {
      let value = this.concern[index]?.notes;
      if (!value) {
        this.errorsConcern[index] = { ...this.errorsConcern[index], notes: true };
      } else {
        this.errorsConcern[index] = { ...this.errorsConcern[index], notes: false };
        return;
      }
    }
  }

  onBlurInput(type: string) {
    setTimeout(() => (this.acFocus[type] = false), 100);
  }

  onBlurAll() {
    setTimeout(() => {
      for (const property in this.acFocus) {
        if (property) {
          this.acFocus[property] = false;
        }
      }
    }, 100);
  }

  getTimeByIndex(index) {
    return time.filter((t) => t.i === index)[0];
  }

  setEndTime(index) {
    if (index !== null && index > -1) {
      const endHourSlots = this.getTimeByIndex(index);
      this.appointment.time.end = endHourSlots.value;
      this.selectedTime.end = endHourSlots;
      localStorage.setItem('endTimePersisted', endHourSlots.value);
    } else {
      this.appointment.time.end = null;
      this.selectedTime.end = '';
    }
  }

  setNextEndDate(today = true) {
    const current = this.helperService.convertDate(this.appointment.date.start);
    if (!today) {
      current.add(1, 'days');
    }
    this.appointment.date.end = current.toDate();
  }

  onSelectStartTime(event) {
    const newTemplate = this.revertTemplateParsing(
      this.templates.confirmation.subject,
      this.templates.confirmation.contents,
      this.templates.cancelReply.contents,
      this.templates.confirmReply.contents,
      this.templates.reminder.contents,
    );

    this.templates.confirmation.contents = newTemplate.confirmationContent;
    this.templates.confirmReply.contents = newTemplate.manualConfirmContent;
    this.templates.cancelReply.contents = newTemplate.manualCancelContent;
    this.templates.reminder.contents = newTemplate.reminderContent;
    this.getTimeDiffrence(event.value);

    this.appointment.time.start = event.value;
    localStorage.setItem('startTimePersisted', event.value);
    const timeInNum = Number(event.value.split(':').join('.'));
    const isBlocked = this.formatBlockedTimes.some((time) => time[0] > timeInNum && time[1] < timeInNum);
    if (!isBlocked) {
      if (event.i < 92) {
        if (this.appointment._id) {
          this.setEndTime(event.i + this.duration / 15);
        } else {
          // const expectedEndTimeIndex = event.i + 4;
          // const time = this.allTimes.find((time: any) => time.i === expectedEndTimeIndex);
          // const timeInNum = Number(time?.value?.split(':')?.join('.'));
          // const isBlocked = this.formatBlockedTimes.some((time) => time[0] < timeInNum && time[1] > timeInNum);
          // if (!isBlocked) {
            this.setEndTime(event.i + 4);
          // } else {
          //   this.setEndTime(null);
          // }
        }
        this.setNextEndDate(true);
      } else if (event.i === 92) {
        this.setEndTime(0);
        this.setNextEndDate(false);
      } else if (event.i === 93) {
        this.setEndTime(1);
        this.setNextEndDate(false);
      } else if (event.i === 94) {
        this.setEndTime(2);
        this.setNextEndDate(false);
      } else if (event.i === 95) {
        this.setEndTime(3);
        this.setNextEndDate(false);
      }
    }

    this.setCommunication();
    this.parseTemplates();
    this.setDisabledReminders();
  }

  getTimeDiffrence(start: any) {
    let startDate: any, endDate: any;
    if (this.appointment.date) {
      startDate = this.dateService.formatDate(this.appointment.date.start, datetimeFormat.mmmdyy);
      endDate = this.dateService.formatDate(this.appointment.date.end, datetimeFormat.mmmdyy);
    }

    if (startDate !== endDate) {
      this.times = this.allTimes;
      this.endTimeDropdown = this.helperService.deepCopy(this.times);
    } else {
      if (this.formatBlockedTimes?.length) {
        this.times = this.allTimes.reduce((acc, time) => {
          const timeValue = Number(time.value?.split(':').join('.'));
          const isBlocked = this.formatBlockedTimes.some((times) => timeValue >= times[0] && timeValue < times[1]);
          if (isBlocked) {
            return acc;
          } else {
            acc.push(time);
            return acc;
          }
        }, []);
      }
      this.endTimeDropdown = this.allTimes.reduce((acc, time) => {
        const timeValue = Number(time.value?.split(':').join('.'));
        if (this.formatBlockedTimes?.length) {
          const isBlocked = this.formatBlockedTimes.some((times) => timeValue > times[0] && timeValue <= times[1]);
          if (isBlocked) {
            return acc;
          }
        }
        let todayDate: any;

        if (this.helperService.isAppleDevice()) {
          todayDate = moment(new Date()).format('MM/DD/YYYY');
        } else {
          todayDate = moment(new Date()).format('MM-DD-YYYY');
        }
        const startDate = new Date(`${todayDate} ${start}`);
        const endDate = new Date(`${todayDate} ${time.value}`);
        const timeDiff = Math.abs(startDate.getTime() - endDate.getTime());

        const hours = Math.abs(timeDiff) / 36e5;
        const diffTime = hours + ' Hr';
        const o: any = Object.assign({}, time);
        o.diffTime = `${o.label} (${diffTime})`;
        acc.push(o);
        return acc;
      }, []);
    }

    this.endTimeDropdown.forEach((time) => {
      if (start < time.value || startDate !== endDate) {
        time.isActiveEndTime = true;
      }
    });
  }

  onSelectEndTime(event) {
    const newTemplate = this.revertTemplateParsing(
      this.templates.confirmation.subject,
      this.templates.confirmation.contents,
      this.templates.cancelReply.contents,
      this.templates.confirmReply.contents,
      this.templates.reminder.contents,
    );
    this.templates.confirmation.contents = newTemplate.confirmationContent;
    this.templates.confirmReply.contents = newTemplate.manualConfirmContent;
    this.templates.cancelReply.contents = newTemplate.manualCancelContent;
    this.templates.reminder.contents = newTemplate.reminderContent;

    this.appointment.time.end = event.value;

    const selectedTime = time.filter((t) => t?.value === event?.value)[0];
    if (selectedTime) {
      this.setEndTime(selectedTime.i);
    }

    if (this.appointment.customer.customerId) {
      this.parseTemplates();
    }

    this.setCommunication();
    this.parseTemplates();
  }

  async onEndDateSelect() {
    const newTemplate = this.revertTemplateParsing(
      this.templates.confirmation.subject,
      this.templates.confirmation.contents,
      this.templates.cancelReply.contents,
      this.templates.confirmReply.contents,
      this.templates.reminder.contents,
    );
    this.templates.confirmation.contents = newTemplate.confirmationContent;
    this.templates.confirmReply.contents = newTemplate.manualConfirmContent;
    this.templates.cancelReply.contents = newTemplate.manualCancelContent;
    this.templates.reminder.contents = newTemplate.reminderContent;
    this.isCustomerFocused = true;
    this.selectedEndDate = this.helperService.getDateByFormat(this.appointment.date.end, 'YYYY-MM-DD');
    this.selectedStartDate = this.appointment.date.start ? this.helperService.getDateByFormat(this.appointment.date.start, 'YYYY-MM-DD') : '';
    if (!this.selectedStartDate) {
      this.selectedStartDate = this.selectedEndDate;
    }
    // await this.setBlockedTimes();
    this.getTimeDiffrence(this.appointment.time.start);
    this.setCommunication();
    this.parseTemplates();
  }

  async onSelectStartDate(event) {
    const newTemplate = this.revertTemplateParsing(
      this.templates.confirmation.subject,
      this.templates.confirmation.contents,
      this.templates.cancelReply.contents,
      this.templates.confirmReply.contents,
      this.templates.reminder.contents,
    );

    this.templates.confirmation.contents = newTemplate.confirmationContent;
    this.templates.confirmReply.contents = newTemplate.manualConfirmContent;
    this.templates.cancelReply.contents = newTemplate.manualCancelContent;
    this.templates.reminder.contents = newTemplate.reminderContent;
    this.selectedStartDate = this.helperService.getDateByFormat(event, 'YYYY-MM-DD');
    this.setNextEndDate();
    this.selectedEndDate = this.appointment.date.end ? this.helperService.getDateByFormat(this.appointment.date.end, 'YYYY-MM-DD') : '';
    if (!this.selectedEndDate) {
      this.selectedEndDate = this.selectedStartDate;
    }
    // await this.setBlockedTimes();
    // if (this.formatBlockedTimes.length) {
    //   this.selectedTime.start = {}
    //   this.selectedTime.end = {}
    // } else await this.setSelectedTime();
    await this.setSelectedTime();
    this.getTimeDiffrence(this.appointment.time.start);
    this.setCommunication();
    this.parseTemplates();
    this.setDisabledReminders();
    setTimeout(() => {
      this.focus.startTime = true;
    }, 100);
  }

  async setBlockedTimes() {
    const res = await this.getBlockedAvailabilities();
    if (this.selectedStartDate === this.selectedEndDate) {
      const records = res[0].records;
      const targetRecord = records.find((r) => r._id.date === this.selectedStartDate);
      const blockedRecords = targetRecord?.records?.filter((r) => r.type === 'block');
      const blockedTimes = blockedRecords?.map((r) => [this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(r.startDateTime).getTime(), this.helperService.getCompany().timezone), datetimeFormat.yyymmddhhmm), this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(r.endDateTime).getTime(), this.helperService.getCompany().timezone), datetimeFormat.yyymmddhhmm)]);
      this.formatBlockedTimes = blockedTimes?.map((b) => [this.helperService.convertTimeToNumber(b[0]), this.helperService.convertTimeToNumber(b[1])]) ?? [];
    }
  }

  onSelectVehicle(vehicle: any, close: any = null) {
    if (this.appointment.vehicle?.vehicleId) {
      const newTemplate = this.revertTemplateParsing(
        this.templates.confirmation.subject,
        this.templates.confirmation.contents,
        this.templates.cancelReply.contents,
        this.templates.confirmReply.contents,
        this.templates.reminder.contents,
      );

      this.templates.confirmation.subject = newTemplate.confirmationSubject;
      this.templates.confirmation.contents = newTemplate.confirmationContent;
      this.templates.confirmReply.contents = newTemplate.manualConfirmContent;
      this.templates.cancelReply.contents = newTemplate.manualCancelContent;
      this.templates.reminder.contents = newTemplate.reminderContent;
      this.customerSearchResults = [];
    }

    if (vehicle && vehicle.vehicleId && vehicle.vehicleId._id) {
      this.appointment.vehicle = {};
      this.appointment.vehicle.vehicleId = vehicle.vehicleId._id;
      this.appointment.vehicle.make = vehicle.vehicleId.make;
      this.appointment.vehicle.year = vehicle.vehicleId.year;
      this.appointment.vehicle.model = vehicle.vehicleId.model;
      this.appointment.vehicle.engine = vehicle.vehicleId.engine;
      this.appointment.vehicle.name = vehicle.name;
      this.selectedVehicle = this.appointment.vehicle;
      this.focus.vehicle = false;
    } else if (vehicle && vehicle._id) {
      this.appointment.vehicle = {};
      this.appointment.vehicle.vehicleId = vehicle._id;
      this.appointment.vehicle.make = vehicle.make;
      this.appointment.vehicle.year = vehicle.year;
      this.appointment.vehicle.model = vehicle.model;
      this.appointment.vehicle.engine = vehicle.engine;
      this.appointment.vehicle.name = vehicle.name;
      this.focus.vehicle = false;
    }

    this.setVehicleAdditionalDetails(vehicle);
    // this.focus.order = true;
    if (close) close();
    this.getTireStorageData(this.appointment?.customer?.customerId || this.appointment?.customer?._id, this.appointment?.vehicle?.vehicleId);
    this.selectedVehicle = this.appointment.vehicle;
    this.parseTemplates();
  }

  setVehicleAdditionalDetails(vehicle: any) {
    if (this.isTireStorage2Enabled && vehicle && vehicle._id && vehicle.apiResponse) {
      this.appointment.vehicle.BaseVehicleID = vehicle.apiResponse?.BaseVehicleID;
      this.appointment.vehicle.EngineID = vehicle.apiResponse?.EngineID;
      this.appointment.vehicle.CountryID = vehicle.apiResponse?.CountryID;
      this.appointment.vehicle.SubModelID = vehicle.apiResponse?.SubModelID;
      this.appointment.vehicle.Year = vehicle.apiResponse?.Year;
      this.appointment.vehicle.MakeName = vehicle.apiResponse?.MakeName;
      this.appointment.vehicle.ModelName = vehicle.apiResponse?.ModelName;
    }
  }

  async getTireStorageData(customerId: string, vehicleId: string) {
    if (!this.dataService.isTireStorage2Enabled) {
      return;
    }
    this.tireStorageInspectionStatus = Statuses.missing;
    this.tiresInfoCount = 0;
    if (customerId && vehicleId) {
      try {
        this.isLoadingTirestorageData = true;
        const data: any = await this.httpService.getItems({ type: 'tireStorage', limit: 100, vehicleId, customerId, sortField: 'createdAt', sortOrder: 1 });
        if (data?.records && data?.records?.length) {
          const filterData: any[] = data.records.filter((item: any) => item?.tireStorageStatus === 'store') || [];
          // if(filterData?.length) {
          //   filterData.filter((item: any) => {
          //     if(item?.tiresInfo?.length) {
          //       return item.tiresInfo.every((tireInfo: any) => { return tireInfo?.storageLocation && tireInfo?.storageLocation?.locationId && tireInfo?.storageLocation?.name});
          //     }
          //   });
          // }
          this.tireStorages = filterData;
          if (filterData?.length) {
            if (filterData[0]?.tiresInfo) {
              this.tiresInfoCount = filterData[0]?.tiresInfo?.length;
            }
            const { orderInspectionId } = filterData[0];
            const { orderId } = filterData[0].storageRO;
            if (orderInspectionId) {
              const actualInspection: any = await this.httpService.getEstimateInspectionDetails(orderInspectionId, orderId, true, true);
              if (actualInspection?.category && actualInspection?.category?.length) {
                const { inspectionItems } = actualInspection?.category[0];
                if (inspectionItems?.length) {
                  const isAllColorIndexZero = inspectionItems.every((item: any) => item?.colorIndex === 0);
                  if (isAllColorIndexZero) {
                    this.tireStorageInspectionStatus = Statuses.completed;
                  } else {
                    this.tireStorageInspectionStatus = Statuses.missing;
                  }
                }
              }
            }
          } else {
            this.tireStorages = [];
            this.tireStorageInspectionStatus = Statuses.nostoredtires;
          }
        } else {
          this.tireStorages = [];
          this.tireStorageInspectionStatus = Statuses.nostoredtires;
        }
      } catch (err: any) {
        this.helperService.showToaster('error', err);
        this.tireStorageInspectionStatus = Statuses.missing;
      } finally {
        this.isLoadingTirestorageData = false;
      }
    }
  }

  openStartDateTime(calendar1: any, calendar2: any, event: Event) {
    event.stopPropagation();
    event.preventDefault();

    calendar1.showOverlay(calendar1);

    try {
      this.startDateCalendarContainer.nativeElement.querySelector('.ui-datepicker-prev').focus();
    } catch (err) {
      console.error(err);
    }
  }

  addNewVehicle() {
    this.createVehicle.emit({
      appointment: this.appointment,
      openFrom: 'add-appointment',
      vehicleName: this.vehicleSearchData,
    });
  }

  onSelectTechnician() {
    if (this.selectedTechnician?.length > 0) {
      this.technicianNameLabel(this.selectedTechnician);
    } else {
      this.acFocusLabel.user = '';
    }
  }

  technicianNameLabel(data) {
    let x = '';
    data.forEach((t, i) => {
      x += `${t.name}`;
      if (data?.length > 1 && i !== data?.length - 1) {
        x += `, `;
      }
    });
    this.acFocusLabel.user = x;
  }

  addReminder(event) {
    event.stopPropagation();
    this.appointment.reminders = [{ key: 'h', frequency: 1 }, ...this.appointment.reminders];
    this.isAddReminderOpen = true;
  }

  reminderDelete(index) {
    this.appointment.reminders.splice(index, 1);
    if (this.appointment.reminders?.length === 0) {
      this.isAddReminderOpen = false;
    }
  }

  notesChange(note, evt) {
    this.acFocusLabel.note = note;
  }

  concernChange(concern, evt, index) {
    if (this.concern[index].notes?.length > 115) {
      this.concern[index].expanded = true;
    } else {
      this.concern[index].expanded = false;
    }
    this.concern[index].notes = concern;
    this.hasConcernedNotes =
      this.concern?.some((item: any) => {
        return item.notes;
      }) || this.concern?.length;
    this.concern[index].lastUpdatedAt = this.dateService.formatDate(new Date(), datetimeFormat.yyymmddhhmm);
  }

  parseTemplates() {
    const startTime = this.allTimes.filter((t) => t.value === this.appointment.time.start)[0];
    const endTime = this.allTimes.filter((t) => t.value === this.appointment.time.end)[0];
    const data = {
      customer: this.appointment.customer,
      company: this.company,
      vehicle: this.appointment.vehicle,
      appointment: {
        startDate: this.dateService.formatDate(this.appointment.date.start, datetimeFormat.dmmmyy),
        startTime: startTime && startTime.label,
        endDate: this.dateService.formatDate(this.appointment.date.end, datetimeFormat.dmmmyy),
        endTime: endTime && endTime.label,
        title: this.appointment.title,
      },
    };

    this.templates.confirmation.subject = this.defaultTemplates.confirmation.subject;
    this.templates.confirmation.contents = this.defaultTemplates.confirmation.contents;
    this.templates.reminder.contents = this.defaultTemplates.reminder.contents;
    const subject = this.helperService.templateParser(this.templates.confirmation.subject, data, true, this.timezones, this.currentLang);
    const confirmation = this.helperService.templateParser(this.templates.confirmation.contents, data, true, this.timezones, this.currentLang);
    const cancelReply = this.helperService.templateParser(this.templates.cancelReply.contents, data, true, this.timezones, this.currentLang);
    const confirmReply = this.helperService.templateParser(this.templates.confirmReply.contents, data, true, this.timezones, this.currentLang);
    this.templates.confirmation.contents = confirmation;
    this.templates.confirmation.subject = subject;
    this.templates.cancelReply.contents = cancelReply;
    this.templates.confirmReply.contents = confirmReply;
    const reminder = this.helperService.templateParser(this.templates.reminder.contents, data, true, this.timezones, this.currentLang);
    this.templates.reminder.contents = reminder;
    this.setEditableContainerContent();
  }

  revertTemplateParsing(confirmationSubject: string, confirmationContent: string, manualCancelContent: string, manualConfirmContent: string, reminderContent: string) {
    const startTime = this.allTimes.filter((t) => t.value === this.appointment.time.start)[0];
    const endTime = this.allTimes.filter((t) => t.value === this.appointment.time.end)[0];
    const data = {
      customer: this.appointment.customer,
      company: this.company,
      vehicle: this.appointment.vehicle,
      appointment: {
        startDate: this.dateService.formatDate(this.appointment.date.start, datetimeFormat.dmmmyy),
        startTime: startTime && startTime.label,
        endDate: this.dateService.formatDate(this.appointment.date.end, datetimeFormat.dmmmyy),
        endTime: endTime && endTime.label,
        title: this.appointment.title,
      },
    };

    return {
      confirmationSubject: this.helperService.revertTemplateParsing(confirmationSubject, data, true),
      confirmationContent: this.helperService.revertTemplateParsing(confirmationContent, data, true),
      manualCancelContent: this.helperService.revertTemplateParsing(manualCancelContent, data, true),
      manualConfirmContent: this.helperService.revertTemplateParsing(manualConfirmContent, data, true),
      reminderContent: this.helperService.revertTemplateParsing(reminderContent, data, true),
    };
  }

  handleSelectTechnician(technicians) {
    this.selectedTechnician = technicians;
  }

  removeOrder(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.estimateSearch('', false);
    this.appointment.estimate = {};
    this.estimateId = '';
    this.estimateSearchKey = '';
    this.estimateVehicleId = '';
    if (this.concern?.length) {
      const concernList = this.getAppointmentOnlyConcerns(this.concern);
      this.concern = concernList || [{ notes: '' }];
    }
    // this.concern = [
    //   {
    //     notes: '',
    //   },
    // ];
  }

  getAppointmentOnlyConcerns(concern: any[]): Array<any>[] {
    let concernList: any[] = [];
    if (concern?.length) {
      concernList = concern.filter((concernItem: any) => {
        if (concernItem.concernCreatedFrom === 'appointment') {
          delete concernItem.orderId;
          return true;
        } else {
          return false;
        }
      });
    }

    if (concernList?.length) {
      return concernList;
    }

    return null;
  }

  openRepairOrder(estimateId: string) {
    this.helperService.openPageInNewExistingTab(`/estimate/${estimateId}`, estimateId);
  }

  removeCustomer() {
    if (this.appointment.type === 'external' && this.appointmentStatus !== 'cancelled') {
      this.openConfirmCancelCustomerDialog();
    } else {
      this.setCustomerNull();
    }

    this.disabled = {
      customer: false,
      vehicle: false,
    };
  }

  removeVehicle() {
    if (this.appointment.vehicle && this.appointment.vehicle.vehicleId === this.estimateVehicleId) {
      const message = `${this.appointment.vehicle.name} is in RO`;
      this.helperService.showToaster('error', message);
      return;
    }

    if (this.appointment.vehicle?.year) {
      const newTemplate = this.revertTemplateParsing(
        this.templates.confirmation.subject,
        this.templates.confirmation.contents,
        this.templates.cancelReply.contents,
        this.templates.confirmReply.contents,
        this.templates.reminder.contents,
      );

      this.templates.confirmation.subject = newTemplate.confirmationSubject;
      this.templates.confirmation.contents = newTemplate.confirmationContent;
      this.templates.confirmReply.contents = newTemplate.manualConfirmContent;
      this.templates.cancelReply.contents = newTemplate.manualCancelContent;
      this.templates.reminder.contents = newTemplate.reminderContent;
      this.setEditableContainerContent();
      this.customerSearchResults = [];
    }

    this.selectedVehicle = {};
    this.appointment.vehicle = {};
  }

  openConfirmCancelCustomerDialog(header?, data?: any) {
    const appointmentData = this.appointment;
    const customer = appointmentData && appointmentData.customer;
    const ref = this.dialogService.open(CancelApptDialogComponent, {
      header: header,
      width: '500px',
      styleClass: 'small-heading-dialog',
      data: {
        _id: this.appointment._id,
        appointment: this.appointment,
        startDate: this.helperService.getDate(appointmentData.startDateTime),
        startTime: this.helperService.getTime(appointmentData.startDateTime),
        endDate: this.helperService.getDate(appointmentData.endDateTime),
        endTime: this.helperService.getTime(appointmentData.endDateTime),
        customer,
        refetch: true,
        currentLang: this.currentLang,
      },
      showHeader: false,
    });

    const onClose = ref.onClose.subscribe(({ type, data }) => {
      if (type === 'dontsend') {
        this.onCustomerDontSendNotification(data);
      }
      if (type === 'send') {
        this.onCustomerSendNotification(data);
      }
      onClose.unsubscribe();
    });
  }

  openAppointmentConfirmationDialog({ payload, issue, appointments }: any, isForcedModalClose?) {
    const prompt = {
      title: '',
      message: '',
    };
    const techNameMap = {};
    let oTechsIds = [],
      nTechsIds = [],
      techName = '';

    if (issue === 'tech-time-conflicts') {
      this.technician.forEach(({ _id, label }) => {
        techNameMap[_id] = label;
      });

      if (this.selectedTechnician && this.selectedTechnician?.length) {
        oTechsIds = this.selectedTechnician.map(({ _id }) => _id);
      }

      if (appointments && appointments?.length) {
        appointments.forEach(({ techs }) => {
          if (techs && techs?.length) {
            techs.forEach(({ techId }) => {
              nTechsIds.push(techId);
            });
          }
        });
      }

      techName = intersection(oTechsIds, nTechsIds)
        .map((id) => techNameMap[id])
        .join(', ');
    }

    if (issue === 'non-working-hours') {
      prompt.title = 'You are setting an appointment in non working hours.';
      prompt.message = 'Are you sure you want to continue?';
    } else if (issue === 'tech-time-conflicts') {
      prompt.title = 'Appointment has a conflict';
      prompt.message = `${techName} already has a scheduled appointment at this time. Are you sure you want to continue?`;
    }

    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-14',
        title: prompt.title,
        message: prompt.message,
        button: {
          success: { title: 'Confirm' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        if (issue === 'non-working-hours') {
          this.onSubmit(true, null, isForcedModalClose);
        } else if (issue === 'tech-time-conflicts') {
          this.onSubmit(true, true, isForcedModalClose);
        }
      }

      onClose.unsubscribe();
    });
  }

  /** Delete the Appt without sending any notification */
  onCustomerDontSendNotification(data) {
    this.setCustomerNull();
    if (data._id && this.appointmentStatus !== 'cancelled') {
      this.deleteAppointment({
        _id: data._id,
      }).then(
        (res) => {
          this.setCustomerNull();
          this.isUpdate = false;
          delete this.appointment._id;
        },
        (err) => {
          this.helperService.showToaster('error', err.message);
        },
      );
    } else if (this.appointmentStatus === 'cancelled') {
      this.setCustomerNull();
    }
  }

  /** Delete the Appt and send the notification */
  onCustomerSendNotification(data) {
    if (this.appointmentStatus !== 'cancelled') {
      this.deleteAppointment({
        _id: data._id,
        isEmail: this.appointment.customer.contactOnEmail,
        isSMS: this.appointment.customer.contactOnPhone,
        customer: data.customer,
        confirmationText: data.content,
      }).then(
        (res) => {
          this.setCustomerNull();
          this.isUpdate = false;
          delete this.appointment._id;
          this.dataService.sendData(this.dataService.typePassData('appt-decline-request', { data: {} }));
        },
        (err) => {
          this.helperService.showToaster('error', err.message);
        },
      );
    } else if (this.appointmentStatus === 'cancelled') {
      this.setCustomerNull();
    }
  }

  /** Make http call to delete the appointment */
  deleteAppointment(data) {
    return this.httpService.deleteAppointment(data);
  }

  setCustomerNull() {
    this.customerSearchKey = '';
    this.estimateSearchKey = '';
    this.estimateVehicleId = '';
    this.appointment.estimate = {};
    this.selectedVehicle = {};
    this.estimateSearchResults = [];
    this.appointment.title = '';
    this.customer = {};
    this.appointment.customer = {
      customerId: null,
      phone: null,
      email: null,
      fullName: null,
      companyName: null,
      contactOnPhone: false,
      contactOnEmail: false,
    };
    this.appointment.switch.confirmation = false;
    this.appointment.switch.reminders = false;
    this.appointment.vehicle = {};
    this.dataService.sendData(this.dataService.typePassData('appointment-title', this.appointment.title));
  }

  validation(startDateTime: any, endDateTime: any) {
    let isValid = true;
    const startDateTimeSecond = new Date(startDateTime).getTime();
    const endDateTimeSecond = new Date(endDateTime).getTime();
    const { confirmation, reminders } = this.appointment.switch;
    const { contactOnEmail, contactOnPhone } = this.appointment.customer;

    this.validate = {};

    if (!this.appointment.title) {
      this.helperService.showToaster('error', messages.enterTitle);
      isValid = false;
    } else if (endDateTimeSecond < startDateTimeSecond || endDateTimeSecond === startDateTimeSecond) {
      this.validate.time = 'Please select a valid time';
      this.helperService.showToaster('error', messages.validTime);
      isValid = false;
    }
    const contacts = [...this.recipients.emails, ...this.recipients.phones, ...this.reminderRecipients.emails, ...this.reminderRecipients.phones];

    if (contacts && contacts?.length && this.appointment && this.appointment.customer && this.appointment.customer.customerId) {
      if ((confirmation || reminders) && !contactOnEmail && !contactOnPhone) {
        this.validate.switch = 'Select a communication preference';
        this.helperService.showToaster('error', messages.communicationPreference);
        isValid = false;
      }

      if (contacts?.length && !contactOnEmail && !contactOnPhone) {
        this.helperService.showToaster('error', 'Please select a communication preference');
        isValid = false;
      }
    }

    const uniqueReminders = uniqWith(this.appointment.reminders, isEqual);

    if (uniqueReminders?.length !== this.appointment.reminders?.length) {
      this.helperService.showToaster('error', 'Multiple reminders cannot be scheduled for the same time');

      isValid = false;
    }

    return isValid;
  }

  isRescheduled(oldStart: any, oldEnd: any, newStart: any, newEnd: any, checkEndTime: boolean = true) {
    if (checkEndTime) {
      return new Date(oldStart).getTime() !== new Date(newStart).getTime() || new Date(oldEnd).getTime() !== new Date(newEnd).getTime();
    } else {
      return new Date(oldStart).getTime() !== new Date(newStart).getTime();
    }
  }

  /** Handling Reschedule appointment actions */
  handleRescheduledAppointment(appointment: any, isForcedTechSchedule: boolean = false) {
    /** Check if appointment is rescheduled */
    if (!isForcedTechSchedule && this.isRescheduled(this.oldappointment.start, this.oldappointment.end, appointment.startDateTime, appointment.endDateTime, false) && appointment.customer.customerId) {
      const ref = this.dialogService.open(UpdateApptDialogComponent, {
        header: '',
        width: '500px',
        styleClass: 'small-heading-dialog',
        data: {
          _id: this.appointment._id,
          appointment: this.appointment,
          startDate: this.helperService.getDate(appointment.startDateTime),
          startTime: this.helperService.getTime(appointment.startDateTime),
          endDate: this.helperService.getDate(appointment.endDateTime),
          endTime: this.helperService.getTime(appointment.endDateTime),
          customer: this.appointment.customer,
          currentLang: this.currentLang.toLowerCase(),
        },
        showHeader: false,
      });

      const onClose = ref.onClose.subscribe(({ type, data }) => {
        if (type === 'send') {
          appointment = {
            ...appointment,
            isEmail: true,
            confirmationText: data?.content,
          };
          this.updateAppoint(appointment);
        } else if (type === 'dontsend') {
          delete appointment.isEmail;
          delete appointment.isSMS;
          this.updateAppoint(appointment);
        } else if (type === 'dismiss') {
          this.setProcessingState(false);
        }
        onClose.unsubscribe();
      });
    } else {
      this.updateAppoint(appointment);
    }
  }

  handleRescheduledAppointmentRequest(appointment: any, isForcedTechSchedule: boolean = false, isForcedModalClose?) {
    /** Check if appointment is rescheduled */
    if (!isForcedTechSchedule && this.isRescheduled(this.oldappointment.start, this.oldappointment.end, appointment.startDateTime, appointment.endDateTime, false)) {
      const ref = this.dialogService.open(UpdateApptDialogComponent, {
        header: '',
        width: '500px',
        styleClass: 'small-heading-dialog',
        data: {
          appointment: this.appointment,
          startDate: this.helperService.getDate(appointment.startDateTime),
          startTime: this.helperService.getTime(appointment.startDateTime),
          endDate: this.helperService.getDate(appointment.endDateTime),
          endTime: this.helperService.getTime(appointment.endDateTime),
          customer: this.helperService.trimString(`${this.appointmentRequest.customer.firstName} ${this.appointmentRequest.customer.lastName}`),
          currentLang: this.currentLang,
        },
        showHeader: false,
      });

      const onClose = ref.onClose.subscribe(({ type }) => {
        if (type === 'send') {
          appointment.isEmail = true;
          this.handleCreateAppointment(appointment, isForcedModalClose);
        } else if (type === 'dontsend') {
          delete appointment.isEmail;
          delete appointment.isSMS;
          this.handleCreateAppointment(appointment, isForcedModalClose);
        } else if (type === 'dismiss') {
          this.setProcessingState(false);
        }
        onClose.unsubscribe();
      });
    } else {
      this.handleCreateAppointment(appointment, isForcedModalClose);
    }
  }

  /** Handling actions that will be taken after creation of new appointment */
  handleNewAppointmentAction(appointment: any) {
    if (appointment.estimate && appointment.estimate.estimateId) {
      this.dataService.sendData(
        this.dataService.typeDialog('estimate', 'appointment', null, null, {
          appointment,
        }),
      );

      this.dataService.sendData(this.dataService.typePassData('appointment-created', appointment));
    }

    if (appointment.estimate && appointment.estimate.estimateId && this.navigateToEstimate) {
      if (appointment.estimate.isNew) {
        if (this.dataService.isGainSightPXEnabled) {
          const estimateCreated: any = {
            roCreationSource: 'Appointment Booking',
            roNumber: appointment.estimate?.code || '',
          };

          (<any>window).aptrinsic('track', 'RO Created', estimateCreated);
        }
      }
      this.helperService.openPageInNewExistingTab(`/estimate/${appointment.estimate.estimateId}?browserSessionToken=${appointment.browserSessionToken}`, appointment.estimate.estimateId);
    }

    this.appointmentCreated.emit({
      type: 'create',
      customer: {
        _id: this.appointment.customer.customerId,
        fullName: this.appointment.customer.fullName,
      },
      vehicle: {
        _id: this.appointment.vehicle.vehicleId,
        name: this.appointment.vehicle.name,
      },
      openFrom: this.openFrom,
      navigateToEstimate: this.navigateToEstimate,
    });
  }

  openCustomerInSidePanel(
    action: string = '',
    type = 'customer',
    vehicleId?
  ) {
    const customer = this.appointment.customer || {};

    if (customer && !customer.customerId) {
      return;
    }

    customer._id = customer.customerId;
    customer.action = action;

    if (type === 'vehicle' && vehicleId) {
      customer.vehicleId = vehicleId;
      customer.zIndex = true;
    }

    this.dataService.sendData(
      this.dataService.typeSidebar(type, customer.customerId, customer.fullName, customer)
    );
  }



  // Submit Appointment
  onSubmit(isForcedSchedule: boolean = false, isForcedTechSchedule: boolean = false, isForcedModalClose?) {
    if (this.appointmentTab) {
      const nonRescheduleStatuses = ['scheduled', 'confirmed', 'draft', 'cancelled'];
      const technicians = [];
      const preferrence = {
        isEmail: this.appointment.customer.contactOnEmail,
        isSMS: this.appointment.customer.contactOnPhone,
      };

      const selectedTime = localStorage.getItem('startTimePersisted');
      const selectedEndTime = localStorage.getItem('endTimePersisted');

      if (selectedTime) {
        this.appointment.time.start = selectedTime;
      }

      if (selectedEndTime) {
        this.appointment.time.end = selectedEndTime;
      }

      const startDateTime = this.dateService.getDateTimeByDateAndTime(this.appointment.date.start, this.appointment.time.start);
      const endDateTime = this.dateService.getDateTimeByDateAndTime(this.appointment.date.end, this.appointment.time.end);

      if (!this.validation(startDateTime, endDateTime)) {
        return;
      }

      if (!isForcedSchedule) {
        const startDaySettings = this.businessDays[this.dateService.getDayOfWeekNum(startDateTime)];
        const isInNonWorkingHour = this.dateService.isAppointmentWithInWorkingHour(startDaySettings || {}, startDateTime, endDateTime);

        if (this.appointment._id) {
          const isRescheduled = this.isRescheduled(
            this.oldappointment.start,
            this.oldappointment.end,
            this.dateService.getDateTimeWithoutTimezone(startDateTime),
            this.dateService.getDateTimeWithoutTimezone(endDateTime),
          );

          if (isRescheduled && !isInNonWorkingHour) {
            /** @todo dialog-workaround */
            setTimeout(() => {
              this.openAppointmentConfirmationDialog(
                {
                  issue: 'non-working-hours',
                },
                isForcedModalClose,
              );
            }, 500);

            return;
          }
        } else {
          if (!isInNonWorkingHour) {
            /** @todo dialog-workaround */
            setTimeout(() => {
              this.openAppointmentConfirmationDialog(
                {
                  issue: 'non-working-hours',
                },
                isForcedModalClose,
              );
            }, 500);

            return;
          }
        }
      }

      if (this.isProcessing) {
        return;
      }

      this.setProcessingState(true);

      /** Only revert templates if changed */
      let confirmationContent = this.templates.confirmation.contents;
      let manualCancelContent = this.templates.cancelReply.contents;
      let manualConfirmContent = this.templates.confirmReply.contents;
      let reminderContent = this.templates.reminder.contents;
      if (!isEqual(this.templates, this._initialTemplates)) {
        const reverted = this.revertTemplateParsing(
          this.templates.confirmation.subject,
          this.templates.confirmation.contents,
          this.templates.cancelReply.contents,
          this.templates.confirmReply.contents,
          this.templates.reminder.contents,
        );
        confirmationContent = reverted.confirmationContent;
        manualCancelContent = reverted.manualCancelContent;
        manualConfirmContent = reverted.manualConfirmContent;
        reminderContent = reverted.reminderContent;
      }

      /** Setting technicians */
      if (this.selectedTechnician?.length) {
        this.selectedTechnician.forEach(({ _id, label }) => technicians.push({ techId: _id, name: label }));
      }

      if (!this.appointment.switch.reminders) {
        this.appointment.reminders = [];
      }
      const appointment: any = {
        isForcedTechSchedule,
        title: this.appointment.title,
        color: this.appointment.color || config.defaultColor,
        confirmationSubject: this.templates.confirmation.subject,
        confirmationText: confirmationContent,
        cancellationText: manualCancelContent,
        manualConfirmationText: manualConfirmContent,
        reminderSubject: this.templates.reminder.subject,
        reminderText: reminderContent,
        notes: this.appointment.notes,
        reminders: this.appointment.reminders,
        estimate: this.appointment.estimate,
        techs: technicians,
        start: this.dateService.getDateTimeWithoutTimezone(startDateTime),
        end: this.dateService.getDateTimeWithoutTimezone(endDateTime),
        startDateTime,
        endDateTime,
        isSMS: preferrence.isSMS,
        isEmail: preferrence.isEmail,
        reschedule: false,
        customer: {},
        vehicle: {},
        isConfirmationOn: this.appointment.switch.confirmation,
        isReminderOn: this.appointment.switch.reminders,
        browserSessionId: Date.now(),
        status: this.appointment.status || (this.customerConfirmation ? 'confirmed' : 'scheduled'),
        manualConfirm: this.customerConfirmation,
      };

      if (this.sourceCampaign && this.sourceCampaign.marketingCampaignId) {
        appointment.marketingCampaign = this.sourceCampaign;
      } else if (this.sourceCampaign && this.sourceCampaign.campaignId) {
        appointment.followUpCampaign = this.sourceCampaign;
      }

      if (this.appointment.removeMarketingCampaign) appointment.removeMarketingCampaign = true;
      if (this.appointment.removeFollowUpCampaign) appointment.removeFollowUpCampaign = true;
      if (this.appointment.removeLeadCampaign) appointment.removeLeadCampaign = true;

      if (this.appointment.followUpCampaign && this.appointment.followUpCampaign._id) {
        appointment.followUpCampaign = this.appointment.followUpCampaign;
        this.appointment.followUpCampaign.campaignId = this.appointment.followUpCampaign._id;
      }

      if (this.appointment.leadCampaign && this.appointment.leadCampaign.leadCampaignId) {
        appointment.leadCampaign = this.appointment.leadCampaign;
      }

      if (this.appointment.customer) {
        appointment.customer = {
          customerId: this.appointment.customer.customerId,
          fullName: this.appointment.customer.fullName,
          firstName: this.appointment.customer.firstName,
          lastName: this.appointment.customer.lastName,
          phone: this.appointment.customer.phone,
          phone2: this.appointment.customer.phone2,
          notes: this.appointment.customer.notes,
          displayName: this.appointment.customer.fullNameQBO,
          companyName: this.appointment.customer.companyName,
          isFleetCustomer: this.appointment.customer.isFleetCustomer,
          email: this.appointment.customer.email,
        };
      }

      // quickfix needs to find a better solution
      if (typeof this.appointment.color !== 'string') {
        this.appointment.color = config.defaultColor;
      }

      if (this.appointment.vehicle) {
        appointment.vehicle = {
          ...this.appointment.vehicle,
          vehicleId: this.appointment.vehicle && this.appointment.vehicle.vehicleId,
          name: this.appointment.vehicle.name,
        };
      }

      if (this.appointment._id) {
        appointment._id = this.appointment._id;

        /** Check if appointment can be rescheduled */
        if (nonRescheduleStatuses.indexOf(this.appointmentStatus) !== -1) {
          delete appointment.reschedule;
          this.handleRescheduledAppointment(appointment, isForcedTechSchedule);
        }
      } else {
        delete appointment.reschedule;
        appointment.confirmationRecipients = [...this.recipients.emails, ...this.recipients.phones];
        appointment.reminderRecipients = [...this.reminderRecipients.emails, ...this.reminderRecipients.phones];

        if (this.appointmentRequest && !this.appointment._id) {
          this.oldappointment = this.helperService.deepCopy(this.appointmentRequest);
          this.handleRescheduledAppointmentRequest(appointment, isForcedTechSchedule, isForcedModalClose);
        } else {
          this.handleCreateAppointment(appointment, isForcedModalClose);
        }
      }
    } else {
      this.setProcessingState(true);
      const startDateTime = this.dateService.getDateTimeByDateAndTime(this.appointment.date.start, this.appointment.time.start);
      const endDateTime = this.dateService.getDateTimeByDateAndTime(this.appointment.date.end, this.appointment.time.end);
      let payload = {
        description: this.blockAppointment.description,
        startDateTime: this.dateService.getDateTimeWithoutTimezone(startDateTime),
        endDateTime: this.dateService.getDateTimeWithoutTimezone(endDateTime),
        type: 'block',
      };

      this.blockAppointmentRequest(payload);
    }
    localStorage.removeItem('startTimePersisted');
    localStorage.removeItem('endTimePersisted');
  }

  handleCreateAppointment(appointment, isForcedModalClose) {
    if (this.appointmentRequest && this.appointmentRequest.code) {
      appointment.appointmentRequests = {
        code: this.appointmentRequest.code,
        appointmentRequestId: this.appointmentRequest._id,
      };
    }
    if (this.tireStorageId && this.isTireStorage2Enabled) {
      appointment.tireStorageId = this.tireStorageId;
    }
    this.httpService.createAppointment(appointment, { source: this.param.source, notificationId: this.param.notificationId }).then(
      (newAppointment) => {
        this.appointmentRequest ? this.updateAppointmentRequestStatus(newAppointment) : null;
        if (newAppointment.isTimeOverlaping) {
          this.openAppointmentConfirmationDialog({
            issue: 'tech-time-conflicts',
            appointments: newAppointment.overlapAppointments,
            payload: {},
          });
          this.setProcessingState(false);
          return;
        }

        if (newAppointment.customer && newAppointment.customer.customerId) {
          this.dataService.sendData(
            this.dataService.typeDialog(
              'sidebar',
              'appointment',
              newAppointment.customer && newAppointment.customer.customerId,
              newAppointment.customer && newAppointment.customer.fullName,
              newAppointment,
            ),
          );
        }

        if (isForcedModalClose) {
          this.dataService.sendData(this.dataService.typeDialog('close-customer-popup', 'appointment'));
        }

        if (this.isCustomerConcernEnabled) {
          if (newAppointment.estimate?.estimateId) this.estimateId = newAppointment.estimate?.estimateId;
          this.concern.forEach((con: any) => {
            con.apptId = newAppointment._id;
            con.orderId = newAppointment.estimate?.estimateId;
          });
          if (this.concern?.length) {
            this.createUpdateConcern(this.concern, newAppointment.estimate);
          }
        }

        if (this.dataService.isGainSightPXEnabled) {
          const apptCreated: any = {
            apptStartDateTime: appointment.startDateTime,
            apptEndDateTime: appointment.endDateTime,
            apptTitle: appointment.title,
            customerId: appointment.customer?.customerId || '',
            customerName: appointment.customer?.fullName || '',
            vehicle: appointment.vehicle?.vehicleId || '',
            vehicleName: appointment.vehicle?.name || '',
            estimateId: appointment.estimate?.estimateId || '',
            estimateNumber: appointment.estimate?.code || '',
            estimateName: appointment.estimate?.title || '',
            isReminderOn: appointment.isReminderOn,
            notes: appointment.notes,
            isSMSSelected: appointment.isSMS,
            isEmailSelected: appointment.isEmail,
            roNumber: appointment.estimate.code || '',
          };

          if (this.isCustomerConcernEnabled) apptCreated.customerConcern = this.concern?.notes || '';
          if (appointment.marketingCampaign && appointment.marketingCampaign.marketingCampaignId) {
            apptCreated.leadSource = appointment.marketingCampaign.title;
          } else if (appointment.followUpCampaign && appointment.followUpCampaign.campaignId) {
            apptCreated.leadSource = appointment.followUpCampaign.title;
          } else if (appointment.leadCampaign && appointment.leadCampaign.leadCampaignId) {
            apptCreated.leadSource = appointment.leadCampaign.title;
          }
          if (this.currentLang.toLowerCase() === 'fr') {
            this.helperService.postGainsightPXEvent('Appts sent in French', apptCreated);
          }
          this.helperService.postGainsightPXEvent('Appointment Created', apptCreated);
        }
        this.handleNewAppointmentAction(newAppointment);
        this.setProcessingState(false);
        if (this.isTireStorage2Enabled) {
          this.showTsCustomToaster();
        }
      },
      (err) => {
        this.setProcessingState(false);
        this.helperService.showToaster('error', err);
      },
    );
  }

  showTsCustomToaster() {
    if (this.isRunTireStorageRoFlow) {
      this.isRunTireStorageRoFlow = false;
      this.dataService.sendData(
        this.dataService.typePassData('show-enhanced-custom-toaster', {
          type: 'show-enhanced-custom-toaster',
          payload: {
            estimateURL: this.estimateURL,
            tsCreatedRoId: this.tsCreatedRoId,
          },
        }),
      );
    }
  }

  handleBlockAppointment(e) {
    this.blockAppointment = e;
  }

  updateAppoint(updateObj: any) {
    this.setProcessingState(true);
    updateObj.isConfirmationOn = this.appointment.switch.confirmation;
    updateObj.isReminderOn = this.appointment.switch.reminders;

    // quickfix needs to find a better solution
    if (typeof updateObj.color !== 'string') {
      updateObj.color = config.defaultColor;
    }
    updateObj.confirmationRecipients = [...this.recipients.emails, ...this.recipients.phones];
    updateObj.reminderRecipients = [...this.reminderRecipients.emails, ...this.reminderRecipients.phones];
    if (this.appointment && this.appointment.appointmentRequests) {
      updateObj.appointmentRequests = {
        code: this.appointment.appointmentRequests.code,
        appointmentRequestId: this.appointment.appointmentRequests.appointmentRequestId,
      };
    }
    if (this.isCustomerConcernEnabled) {
      if (updateObj.estimate?.estimateId) this.concern.orderId = updateObj.estimate?.estimateId;
      if (!this.apptId) {
        this.apptId = updateObj._id;
      }

      if (this.concern) {
        this.createUpdateConcern(this.concern, updateObj.estimate);
      }
    }

    this.httpService.updateAppointment(updateObj).then(
      (res) => {
        if (res.isTimeOverlaping) {
          this.openAppointmentConfirmationDialog({
            issue: 'tech-time-conflicts',
            appointments: res.overlapAppointments,
            payload: {},
          });
          this.setProcessingState(false);
          return;
        }

        this.appointmentRequest ? this.updateAppointmentRequestStatus(updateObj) : null;

        if (res && res.customer && res.customer._id) {
          this.dataService.sendData(this.dataService.typeDialog('sidebar', 'appointment', res.customer._id, res.customer.fullName, res.customer));
        }

        if (updateObj.estimate && updateObj.estimate._id) {
          this.dataService.sendData(
            this.dataService.typeDialog('estimate', 'appointment', null, null, {
              appointment: { ...updateObj, isEdit: true },
            }),
          );
        }

        const appointmentData = {
          type: 'update',
          customer: {},
          vehicle: {},
          openFrom: this.openFrom,
          navigateToEstimate: this.navigateToEstimate,
          updateObj: updateObj,
        };

        if (this.appointment.customer) {
          appointmentData.customer = {
            _id: this.appointment.customer.customerId,
            fullName: this.appointment.customer.fullName,
          };
        }

        if (this.appointment.vehicle) {
          appointmentData.vehicle = {
            _id: this.appointment.vehicle.vehicleId,
            name: this.appointment.vehicle.name,
          };
        }

        this.appointmentCreated.emit(appointmentData);
        this.helperService.showToaster('success', messages.appointmentDateChange);

        if (res && res.estimateId && res.isNew) {
          this.estimateId = res.estimateId;
          if (!this.apptId) {
            this.apptId = updateObj._id;
          }

          if (this.concern && this.isCustomerConcernEnabled && res?.estimateId) {
            this.createUpdateConcern(this.concern, res);
          }
          if (this.dataService.isGainSightPXEnabled) {
            const estimateCreated: any = {
              roCreationSource: 'Appointment Booking',
              roNumber: res?.code || '',
            };

            (<any>window).aptrinsic('track', 'RO Created', estimateCreated);
          }
          this.helperService.openPageInNewTab(`/estimate/${res.estimateId}?browserSessionToken=${res.browserSessionToken}`);
        }
        if (this.isTireStorage2Enabled) {
          this.showTsCustomToaster();
        }
        this.setProcessingState(false);
      },
      (err) => {
        this.setProcessingState(false);
        this.helperService.showToaster('error', err);
      },
    );
  }

  createUpdateConcern(concern, estimate) {
    let updatedConcern = this.concern.map((item, index) => {
      item.index = index + 1;
      if (this.isDvi2Enabled) {
        item.concernType = 'customerConcern';
      }
      if (this.apptId) {
        item.apptId = this.apptId;
      }
      if (!this.estimateId) {
        const { orderId, ...rest } = item;
        if (!rest?.concernCreatedFrom || rest?.concernCreatedFrom === 'appointment') {
          rest.concernCreatedFrom = 'appointment';
        }
        return rest;
      }
      const concernItem = { ...item, orderId: this.estimateId };
      if (!concernItem?.concernCreatedFrom || concernItem?.concernCreatedFrom === 'appointment') {
        concernItem.concernCreatedFrom = 'appointment';
      }
      return concernItem;
    });
    if (!estimate?.estimateId) {
      updatedConcern = this.getAppointmentOnlyConcerns(updatedConcern);
    }

    if (updatedConcern?.length) {
      updatedConcern = updatedConcern.filter((item) => item.notes && item.notes.trim() !== '');
    }

    if (this.appointment._id) {
      if (updatedConcern?.length) {
        this.httpService.updateOrderConcernList(updatedConcern).then((res) => {
          this.getOrderConcerns();
        });
      }
    } else {
      this.httpService.createOrderConcern(updatedConcern).then((res) => {
        if (this.dataService.isGainSightPXEnabled && updatedConcern?.length) {
          concern.formatUpdatedAt = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(res.updatedAt).getTime()), datetimeFormat.mmmdyyhhmmaa);
          const concernCreated: any = {
            customerConcernCreationSource: 'Appointment Create Concern',
            customerConcernText: concern,
            customerConcernDateTime: concern.formatUpdatedAt,
            roCode: estimate?.code || '',
          };

          (<any>window).aptrinsic('track', 'Customer Concern Created', concernCreated);
        }
      });
    }
  }

  getOrderConcerns() {
    this.httpService.getOrderConcerns({ apptId: this.apptId }).then((concern) => {
      if (concern?.length) {
        this.concern = concern.sort((a, b) => a.index - b.index);
      }
    });
  }

  checkForPreviousAppt() {
    const { date, time } = this.appointment;
    const datetime = this.dateService.getDateTimeByDateAndTime(date.start, time.start);
    const currentTimeTz = this.dateService.getCurrentDateTimeTz(this.currentDateTime);

    return currentTimeTz.getTime() > datetime.getTime();
  }

  renderPeriod(key: string, frequency: number) {
    const period = {
      h: 'hour',
      w: 'week',
      d: 'day',
    };
    return `${period[key]}${frequency > 1 ? 's' : ''}`;
  }

  handleChange(key: string, event: any) {
    if (key === 'followUpCampaign') {
      this.appointment.followUpCampaign = event;
    } else {
      this.templates[key].contents = event.target.innerHTML;
    }
  }

  scrollToBottom() {
    setTimeout(() => {
      try {
        this.addAppointemnt.nativeElement.scrollTop = this.addAppointemnt.nativeElement.scrollHeight + 40;
      } catch (err) { }
    }, 100);
  }

  scrollToTop(scrollHeight: number) {
    setTimeout(() => {
      try {
        this.addAppointemnt.nativeElement.scrollTop = scrollHeight;
      } catch (err) { }
    }, 100);
  }

  openUpdateRecipientDialog(type: string) {
    const { contactOnPhone, contactOnEmail } = this.appointment.customer || {
      contactOnPhone: false,
      contactOnEmail: false,
    };

    if (!contactOnPhone && !contactOnEmail) return;
    if (this.useConfirmationRecipient && type === 'reminder') return;

    let recipients = [];

    if (type === 'confirmation') {
      recipients = [...this.recipients.emails.map(({ value }) => value), ...this.recipients.phones.map(({ value }) => value)];
    } else {
      recipients = [...this.reminderRecipients.emails.map(({ value }) => value), ...this.reminderRecipients.phones.map(({ value }) => value)];
    }

    const ref = this.dialogService.open(UpdateRecipientDialogComponent, {
      closeOnEscape: false,
      width: '650px',
      styleClass: 'add-dialog add-receipt-modal update-contact-dialog',
      showHeader: false,
      data: {
        customerId: this.customer._id,
        email: this.customer.email,
        phone: this.customer.phone,
        isFleetCustomer: this.customer.isFleetCustomer,
        recipients: recipients,
        contactOnPhone: this.appointment.customer.contactOnPhone,
        contactOnEmail: this.appointment.customer.contactOnEmail,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        const contactNotifMap = {};
        const recipients = {
          emails: [],
          phones: [],
        };

        if (data.contacts && data.contacts && data.contacts?.length) {
          for (let i = 0; i < data.contacts?.length; i++) {
            const { _id, value, contactType, isChecked, isMarketingNotifEnabled, isOperationalNotifEnabled } = data.contacts[i];
            const contact = {
              value,
              recipientId: _id,
              type: contactType,
              isMarketingNotifEnabled,
              isOperationalNotifEnabled,
            };

            contactNotifMap[_id] = { isMarketingNotifEnabled, isOperationalNotifEnabled };

            if (isChecked) {
              if (contactType === 'email') {
                recipients.emails.push(contact);
              } else {
                recipients.phones.push(contact);
              }
            }
          }
        }

        if (type === 'confirmation') {
          this.recipients = this.helperService.deepCopy(recipients);

          if (this.useConfirmationRecipient) {
            this.reminderRecipients = this.helperService.deepCopy(this.recipients);
          }
        } else {
          this.reminderRecipients = this.helperService.deepCopy(recipients);
        }

        this.setOperationalNotification(contactNotifMap);

        this.unsubscriptionTooltip = this.helperService.unsubscriptionReminderTooltip(this.reminderRecipients);
        this.isReminderDisabled = !(
          this.reminderRecipients.emails.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled)?.length +
          this.reminderRecipients.phones.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled)?.length
        );
        this.appointment.switch.reminders = !this.isReminderDisabled;
        this.confirmationRecipientTooltip = this.helperService.createContactTooltip(this.recipients, 'Confirmation');
        this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder', true);
      }

      onClose.unsubscribe();
    });
  }

  handleContactPrefChange(type: string, value: boolean) {
    const { customer } = this.appointment;

    if (customer && customer.contacts) {
      this.setRecipient(customer.contacts, type);
    }
  }

  setOperationalNotification(contactMap: any) {
    if (this.recipients.emails && this.recipients.emails?.length) {
      this.recipients.emails.forEach((recip: any) => {
        if (contactMap[recip.recipientId]) {
          recip.isMarketingNotifEnabled = contactMap[recip.recipientId].isMarketingNotifEnabled;
          recip.isOperationalNotifEnabled = contactMap[recip.recipientId].isOperationalNotifEnabled;
        }
      });
    }

    if (this.reminderRecipients.emails && this.reminderRecipients.emails?.length) {
      this.reminderRecipients.emails.forEach((recip: any) => {
        if (contactMap[recip.recipientId]) {
          recip.isMarketingNotifEnabled = contactMap[recip.recipientId].isMarketingNotifEnabled;
          recip.isOperationalNotifEnabled = contactMap[recip.recipientId].isOperationalNotifEnabled;
        }
      });
    }

    if (this.recipients.phones && this.recipients.phones?.length) {
      this.recipients.phones.forEach((recip: any) => {
        if (contactMap[recip.recipientId]) {
          recip.isMarketingNotifEnabled = contactMap[recip.recipientId].isMarketingNotifEnabled;
          recip.isOperationalNotifEnabled = contactMap[recip.recipientId].isOperationalNotifEnabled;
        }
      });
    }

    if (this.reminderRecipients.phones && this.reminderRecipients.phones?.length) {
      this.reminderRecipients.phones.forEach((recip: any) => {
        if (contactMap[recip.recipientId]) {
          recip.isMarketingNotifEnabled = contactMap[recip.recipientId].isMarketingNotifEnabled;
          recip.isOperationalNotifEnabled = contactMap[recip.recipientId].isOperationalNotifEnabled;
        }
      });
    }
  }

  setRecipient(contacts: any[], type: string = '') {
    this.appointment.customer.contacts = this.helperService.deepCopy(contacts);

    if (contacts && contacts?.length) {
      const { contactOnEmail, contactOnPhone } = this.appointment.customer;

      if (!contactOnEmail) {
        this.recipients.emails = [];
        this.reminderRecipients.emails = [];
      }

      if (!contactOnPhone) {
        this.recipients.phones = [];
        this.reminderRecipients.phones = [];
      }

      contacts.forEach(({ _id, value, contactType, isPrimary, isMarketingNotifEnabled, isOperationalNotifEnabled }) => {
        if (isPrimary) {
          if (contactType === 'email' && contactOnEmail && ['', 'contactOnEmail'].includes(type)) {
            this.recipients.emails = [{
              type: 'email',
              value,
              recipientId: _id,
              isMarketingNotifEnabled,
              isOperationalNotifEnabled
            }];
          } else if (contactType === 'mobile' && contactOnPhone && ['', 'contactOnPhone'].includes(type)) {
            this.recipients.phones = [{
              type: 'mobile',
              value,
              recipientId: _id,
              isMarketingNotifEnabled,
              isOperationalNotifEnabled
            }];
          }
        }
      });

      if (this.useConfirmationRecipient) {
        this.reminderRecipients = this.helperService.deepCopy(this.recipients);
        this.unsubscriptionTooltip = this.helperService.unsubscriptionReminderTooltip(this.reminderRecipients);
        this.isReminderDisabled = !(
          this.reminderRecipients.emails.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled)?.length +
          this.reminderRecipients.phones.filter(({ isOperationalNotifEnabled }) => isOperationalNotifEnabled)?.length
        );
        this.appointment.switch.reminders = !this.isReminderDisabled;
        this.appointment.switch.confirmation = !this.isReminderDisabled;
      }

      this.confirmationRecipientTooltip = this.helperService.createContactTooltip(this.recipients, 'Confirmation');
      this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder', true);
    }
  }




  getAppointmentRequestById() {
    if (this.appointment.appointmentRequests && this.appointment.appointmentRequests.appointmentRequestId && this.isApptRequestPortalEnabled) {
      let conf = {
        search: this.appointment.appointmentRequests.code,
        // id: this.appointment.appointmentRequests.appointmentRequestId,
        startDate: '',
        status: [],
      };
      this.httpService.getAppointmentRequest(conf).then((response) => {
        this.appointmentRequest = response[0].records[0].records[0];
        this.appointmentRequest.startDateTime = this.dateService.getCurrentDateTimeTz(new Date(this.appointmentRequest.startDateTime).getTime());
        this.appointmentRequest.startDateTime = this.dateService.formatDate(this.appointmentRequest.startDateTime, datetimeFormat.yyymmddhhmm);
        this.appointmentRequest.start = this.appointmentRequest.startDateTime;
      });
    }
  }

  appointRequest(event) {
    const props = this.appointmentRequest;
    let VIN = '';
    let vehicleFullName = '';
    let customerDetails = '';
    let fullName = '';
    let phoneNo = '';
    let email = '';
    let vehicleDropoff = '';

    const customer = props.customer || {};
    const vehicle = (props.vehicle && props.vehicle.vehicleId) || {};

    if (customer.fullName) {
      fullName = customer.fullName || '';
      phoneNo = customer.phone || '';
      customerDetails = `${fullName}
      ${this.helperService.formatPhoneNumber(phoneNo)}`;
    }

    if (customer.firstName) {
      fullName = `${customer.firstName} ${customer.lastName}`;
      phoneNo = customer.phone || '';
      email = customer.email || '';
      customerDetails = `${fullName}
      ${this.helperService.formatPhoneNumber(phoneNo)}`;
      vehicleDropoff = props?.isVehicleDropOff;
      vehicleFullName = props?.vehicle?.name || '';
    }

    if (vehicle._id) {
      vehicle.licensePlateNo = vehicle.licensePlateNo ? `(${vehicle.licensePlateNo})` : '';
      vehicleFullName = `${vehicle.vehicleName || vehicle.name || ''} ${vehicle.licensePlateNo}`;
      VIN = vehicle.VIN || '';
    }

    let startDate, endDate;

    if (this.helperService.isAppleDevice()) {
      startDate = new Date(this.dateService.madeDateStringIOSCompatible(props.start));
      endDate = new Date(this.dateService.madeDateStringIOSCompatible(props.end));
    } else {
      startDate = new Date(props.start);
      endDate = new Date(props.end);
    }
    let preferredDate = this.dateService.formatDate(startDate, datetimeFormat.hhmmammmdd);
    let createdDate: any = this.dateService.getCurrentDateTimeTz(new Date(props.createdAt).getTime());
    createdDate = this.dateService.formatDate(createdDate, datetimeFormat.mmmdchhmma);
    let leadSource = props.leadCampaign || '';
    let description = props.description || '';
    let declineReason = props.status === 'declined' ? props.declineReason || '' : '';
    let categoryServices: any = [];
    props &&
      props.serviceCategories &&
      props.serviceCategories.map((x) => {
        if (x.services && x.services?.length > 0) {
          x.services.map((y) => {
            if (y && y.name) {
              categoryServices.push(
                `<div class="single-pill">
            <input type="checkbox" class="btn-check" id="btn-check-outlined" autocomplete="off">
            <label class="btn btn-outline-primary" for="btn-check-outlined">${y.name}</label>
          </div>`,
              );
            }
          });
        }
      });
    categoryServices = categoryServices.join(' ');

    if (this.tippyInstances[props._id]) {
      try {
        this.tippyInstances[props._id].destroy();
      } catch (err) { }
    }
    let status =
      props.status === 'requested'
        ? '<img src="./assets/img/apt-reserved.png" alt="apt-reserved" />'
        : props.status === 'declined'
          ? '<img src="./assets/img/apt-decline.png" alt="apt-reserved" />'
          : 'C';

    // Card Tooltips Tippy
    let self = this;
    let instance: Instance;
    instance = tippy(event, {
      theme: 'autoleap',
      allowHTML: true,
      arrow: true,
      boundary: 'viewport',
      interactive: false,
      placement: 'left',
      trigger: 'click',
      maxWidth: 440,
      zIndex: 999999,
      popperOptions: {
        modifiers: {
          // @ts-ignore
          flip: {
            boundariesElement: 'scrollParent',
          },
        },
      },
      content: `<style>
    .tippy-arrow {color: white;}
    .tippy-box[data-placement='bottom'] .tippy-content .card-tooltip-wrapper {
      border-top-color: ${props.color};
    }
    .tippy-box[data-placement='top'] .tippy-content .card-tooltip-wrapper {
      border-bottom-color: ${props.color};
    }
    .tippy-box[data-placement='left'] .tippy-content .card-tooltip-wrapper {
      border-left-color: ${props.color};
    }
    .tippy-box[data-placement='right'] .tippy-content .card-tooltip-wrapper {
      border-right-color: ${props.color};
    }
    </style>
      <div class="card-tooltip-wrapper">
        <div class="appt-tooltip">
          <div class="appt-header">
            <div class="appt-header-title">
              <div class="sd-appointment-label schedule-${props._id}">
                ${status == 'C' ? `<i class="fas fa-check-circle" *ngIf="request.status == 'confirmed'"></i>` : `<i class="reserve-appointment">${status}</i>`}
                <p class="capitalize">APR#${props.code}: ${fullName}</p>
              </div>
              <p class="font-12">Appointment requested at ${createdDate}</p>
            </div>
          </div>
          <div class="appt-body">
            <div class="appt-body-inner">
              <div class="appt-form">
                <div class="appt-sfield">
                  <i class="fal fa-clock"></i>
                  <div class="form-group">
                    <label>Preferred Date & Time:</label>
                    <input type="text" class="form-control" value="${preferredDate}">
                  </div>
                </div>
                <div class="appt-sfield">
                  <i class="fal fa-user"></i>
                  <div class="form-group">
                    <label>Customer:</label>
                    <input type="text" class="form-control capitalize" value="${fullName}">
                    <div class="form-text">
                      <p>${this.helperService.formatPhoneNumber(phoneNo)}</p>
                      <p>${email}</p>
                    </div>
                  </div>
                </div>
                ${vehicleFullName
          ? `
                <div class="appt-sfield">
                  <i class="fal fa-cars"></i>
                  <div class="form-group">
                    <label>Vehicle:</label>
                    <input type="text" class="form-control" value="${vehicleFullName}">
                  </div>
                </div>
                `
          : ''
        }
                ${leadSource
          ? `
                <div class="appt-sfield">
                  <i class="fas fa-bullseye-arrow"></i>
                  <div class="form-group">
                    <label>Lead source:</label>
                    <input type="text" class="form-control" value="${leadSource?.title}">
                    <div class="form-text">
                      <p>Sent on ${this.dateService.formatDate(startDate, datetimeFormat.hhmmaammmdyy)}</p>
                    </div>
                  </div>
                </div>
                `
          : ''
        }
              </div>
            </div>
            <div class="appt-body-inner">
              <div class="check-pills">
                <div class="row mx-0">
                  <div class="col-md-12 px-0">
                    <p>Vehicle Drop-off?</p>
                  </div>
                  <div class="col-md-12 px-0">
                    <div class="pill-group">
                     <div class="single-pill">
                        <input type="checkbox" class="btn-check" id="btn-check-outlined" autocomplete="off">
                        <label class="btn btn-outline-primary" for="btn-check-outlined">${vehicleDropoff ? 'I will drop off my vehicle' : 'I will wait with my vehicle'}</label>
                      </div>
                    </div>
                  </div>
                </div>
                ${categoryServices
          ? `
                <div class="row mx-0">
                  <div class="col-md-12 px-0">
                    <p>Services</p>
                  </div>
                  <div class="col-md-12 px-0">
                    <div class="pill-group">
                     ${categoryServices}
                    </div>
                  </div>
                </div>
                `
          : ''
        }
              </div>
              ${description
          ? `
              <div class="problem-desc">
                <h5>Problem description</h5>
                <p>${description}</p>
              </div>
              `
          : ''
        }

              ${declineReason
          ? `
                    <div class="problem-desc">
                      <h5>Reason for declining</h5>
                      <p>${declineReason}</p>
                    </div>
                    `
          : ''
        }

            </div>
          </div>
        </div>
      </div>`,
    });
    this.tippyInstances[props._id] = instance;
    this.tippyInstances[props._id].show();
  }

  checkTimeSlot() {
    this.setProcessingState(false);
    this.helperService.showToaster('error', 'Select valid time slot');
  }

  blockAppointmentRequest(payLoad) {
    if (this.blockAppointment && this.blockAppointment._id) {
      payLoad._id = this.blockAppointment._id;
      this.httpService
        .updateAppointmentRequest(payLoad)
        .then((x) => {
          this.appointmentCreated.emit({
            type: 'create',
            customer: {
              _id: this.appointment.customer.customerId,
              fullName: this.appointment.customer.fullName,
            },
            vehicle: {
              _id: this.appointment.vehicle.vehicleId,
              name: this.appointment.vehicle.name,
            },
            color: this.appointment.color,
            openFrom: this.openFrom,
            navigateToEstimate: this.navigateToEstimate,
          });
          if (this.isTireStorage2Enabled) {
            this.showTsCustomToaster();
          }
          this.setProcessingState(false);
        })
        .catch((x) => this.checkTimeSlot());
    } else {
      this.httpService
        .createAppointmentRequestFromApp(null, payLoad)
        .then((x) => {
          this.appointmentCreated.emit({
            type: 'create',
            customer: {
              _id: this.appointment.customer.customerId,
              fullName: this.appointment.customer.fullName,
            },
            vehicle: {
              _id: this.appointment.vehicle.vehicleId,
              name: this.appointment.vehicle.name,
            },
            openFrom: this.openFrom,
            navigateToEstimate: this.navigateToEstimate,
            color: this.appointment.color,
          });
          if (this.isTireStorage2Enabled) {
            this.showTsCustomToaster();
          }
          this.setProcessingState(false);
        })
        .catch((x) => this.checkTimeSlot());
    }
  }

  updateAppointmentRequestStatus(appointment?) {
    let payLoad: any = Object.assign({}, this.appointmentRequest);
    if (appointment && appointment.startDateTime) {
      payLoad.startDateTime = this.appointmentRequest.start;
      payLoad.endDateTime = this.appointmentRequest.end;
      payLoad.status = 'confirmed';
      payLoad.appointment = {
        title: appointment.title,
        startDateTime: payLoad.startDateTime,
        endDateTime: payLoad.startDateTime,
        status: appointment.status,
        appointmentId: appointment._id,
      };
      payLoad.type = 'customer';

      delete payLoad.start;
      delete payLoad.end;
    }
    this.httpService.updateAppointmentRequest(payLoad).then((x) => {
      this.dataService.sendData(this.dataService.typePassData('update-appt-column', { data: x }));
    });
  }

  deleteAppointmentRequest() {
    let conf = {
      search: this.appointment.appointmentRequests.code,
      startDate: '',
      endDate: '',
      status: ['status', 'confirmed'],
    };
    this.httpService.getAppointmentRequest(conf).then((response) => {
      let payload = response[0].records[0].records[0];

      payload.startDateTime = this.dateService.getCurrentDateTimeTz(new Date(payload.startDateTime).getTime());
      payload.startDateTime = this.dateService.formatDate(payload.startDateTime, datetimeFormat.yyymmddhhmm);

      payload.endDateTime = this.dateService.getCurrentDateTimeTz(new Date(payload.endDateTime).getTime());
      payload.endDateTime = this.dateService.formatDate(payload.endDateTime, datetimeFormat.yyymmddhhmm);

      payload.status = 'requested';
      payload.type = 'customer';
      delete payload.start;
      payload.appointment = null;
      this.httpService.updateAppointmentRequest(payload).then((x) => {
        this.dataService.sendData(this.dataService.typePassData('update-appt-column', { data: x }));
      });
    });
  }

  showAppointment(type) {
    if (!this.hideAppointmentTab) {
      this.appointment.title = '';
      this.dataService.sendData(this.dataService.typePassData('appointment-title', this.appointment.title));
      if (type === 'appointment') {
        this.appointmentTab = true;
        this.blockTab = false;
      }
      if (type === 'block') {
        this.appointmentTab = false;
        this.blockTab = true;
      }
    }
  }

  /** Handle tab change in sidebar */
  handleTabChange({ index }) {
    this.index = index;
    if (this.index == 0) {
      this.customerConfirmation = false;
    } else {
      this.customerConfirmation = true;
      if (!this.appointment.status) {
        this.appointment.status = 'confirmed';
      }
    }
  }

  checkPreferredLocation(customer: any) {
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    if (isMultiLocationEnabled && customer?.preferredLocation?.locationId) {
      if (this.dataService.currentShopId !== customer?.preferredLocation?.locationId) {
        this.openPreferredLocationDialog();
      }
    }
  }

  openPreferredLocationDialog() {
    if (!this.appointment?.customer?.customerId) return;

    const { fullName, preferredLocation } = this.appointment.customer;
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '35%',
      styleClass: 'add-dialog',
      showHeader: false,
      data: {
        isCustomizedConfirmationBox: true,
        isHTML: true,
        styleClassHeading: 'font-18 font-700',
        title: `Do you want to update ${fullName}'s preferred location`,
        message: `<div>
                    <p class="m-0 font-secondary font-12 mb-2">
                      Existing location of user:
                    </p>
                    <p class="m-0 font-16">
                      ${preferredLocation?.name || 'No location selected'}
                      </p>
                  </div>`,
        button: {
          success: { title: `Update to ${this.dataService.currentShop?.shopFullName}` },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        const payload = {
          preferredLocation: {
            locationId: this.dataService.currentShopId,
            name: this.dataService.currentShop?.shopFullName,
          },
        };
        this.httpService.updateCustomerLocation(this.appointment?.customer?.customerId, payload).then(
          () => {
            this.helperService.showToaster('success', 'Preferred location updated successfully.');
            this.dataService.sendData(this.dataService.typePassData('customer-location-updated', {}));
          },
          (err) => {
            this.helperService.showToaster('error', err);
          },
        );
      }
      onClose.unsubscribe();
    });
  }

  handleAddConcern(type: string, isFocused: boolean = true) {
    if (type === 'concern') {
      let obj: any = {
        notes: '',
        apptId: this.appointment._id,
        orderId: this.estimateId || null,
        index: this.concern?.length + 1,
      };
      if (this.isDvi2Enabled) {
        obj.concernType = 'customerConcern';
      }

      this.concern.push(obj);
      if (isFocused) {
        this.acFocus.concern = true;
        this.focusConcern[this.concern?.length - 1] = { ...this.focusConcern[this.concern?.length - 1], concern: true };
      }
    }
  }

  toggleRowExpansion(index) {
    this.concern[index].expanded = !this.concern[index].expanded;
  }

  deleteConcern(concern, index) {
    // if (!concern._id) return;
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '50%',
      styleClass: 'small-heading-dialog parts-ordering',
      showHeader: false,
      data: {
        isCustomizedConfirmationBox: true,
        headerIconType: 'header-icon',
        isHTML: true,
        type: 'Confirm',
        styleClassHeading: 'font-18 font-700',
        styleClassCloseIcon: 'font-24 font-400 font-gray',
        headerIcon: 'fas fa-trash font-icon-red',
        title: 'Delete Concern',
        message: `
        <span class="font-14 font-400 font-gray">
        Are you sure you want to delete this concern?
        </span>`,
        button: {
          success: {
            title: 'Delete',
            backgroundColor: '#D47877',
          },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onCloseConfirmationDialog = ref.onClose.subscribe((close: any) => {
      if (close.isSuccess) {
        if (concern._id) {
          this.httpService.deleteOrderConcern(concern._id).then(
            (res) => {
              this.concern.splice(findIndex(this.concern, { _id: concern._id }), 1);
              this.helperService.showToaster('success', 'Concern deleted successfully');
            },
            (error) => {
              this.helperService.showToaster('error', error);
            },
          );
        } else {
          this.concern.splice(index, 1);
          if (this.concern?.length === 0) {
            this.handleAddConcern('concern');
            this.focusConcern = [{ concern: false }];
            this.acFocus.concern = false;
          }
        }
      }
      onCloseConfirmationDialog.unsubscribe();
    });
  }

  openTireStorageSideDrawer() {
    if (this.isTireStorage2Enabled && this.tireStorages?.length) {
      this.dataService.sendData(
        this.dataService.typeTireStorageSideBar('appointment', {
          vehicle: this.helperService.deepCopy(this.appointment.vehicle),
          customer: this.helperService.deepCopy(this.appointment.customer),
          tireStorages: this.helperService.deepCopy(this.tireStorages),
          customFleetSettings: this.helperService.deepCopy(this.customFleetSettings),
          isTireScheduleForReturn: this.appointment?.estimate && this.appointment?.estimate?.isTireScheduleForReturn,
          estimateURL: this.appointment?.estimate && this.appointment?.estimate?.isTireScheduleForReturn ? this.estimateURL : '',
        }),
      );
    }
  }

  //check driver matches searched text
  checkDriverWithSearchedField(driverDetails: any) {
    const rawSearch = this.customerSearchData?.toLowerCase();
    const formattedSearch = this.helperService.removePhoneFormatting(rawSearch);

    const driverPhone = this.helperService.removePhoneFormatting(driverDetails?.driverPhone);

    const driverSearchField =
      `${driverDetails.driverName} ${driverPhone} ${driverDetails.companyName} ${driverDetails.driverEmail} ${driverDetails.employeeNumber} ${driverDetails.serviceCardNumber}`?.toLowerCase();

    return driverSearchField.includes(formattedSearch) || driverSearchField.includes(rawSearch);
  }
}
